import { FillMode, CompoundType, PatternFill, setFillStyle, Stroke, imageCache, ImageFilter, generateEffectFilters, DefaultDisplayOptions } from '@tencent/alloy-renderer-adapter';
export { DisplayRule, DisplayScene, FillMode, GradFill, GradientType, RectGradientFill, ShapeGradientFill, StrokeType, generateEffectFilters, imageCache, setFillStyle } from '@tencent/alloy-renderer-adapter';
import { d as _defineProperty, _ as _createClass, a as _classCallCheck, e as _toConsumableArray, f as _inherits, g as _getPrototypeOf, h as _possibleConstructorReturn, i as _get, c as _slicedToArray, j as __awaiter, r as regenerator } from './vendor-c1f6c9fe.esm.js';
import { BrowserCanvas } from '@tencent/alloy-renderer-browser';
import { LineCap, SvgGraphics, PathParser, Fill, Container, Bounds } from '@tencent/alloy-renderer';
import { G as GraphicsType, i as isCalcError, S as SpreadJS, L as LineType } from './spreadJS-b18ad196.esm.js';
export { G as GraphicsType } from './spreadJS-b18ad196.esm.js';
import 'lodash/has';

var LineEndType;
(function (LineEndType) {
  /**
   * 无箭头
   */
  LineEndType["NONE"] = "none";
  /**
   * 三角形箭头
   */
  LineEndType["TRIANGLE"] = "triangle";
  /**
   * 开放型箭头
   */
  LineEndType["ARROW"] = "arrow";
  /**
   * 燕尾箭头OVAL
   */
  LineEndType["STEALTH"] = "stealth";
  /**
   * 钻石
   */
  LineEndType["DIAMOND"] = "diamond";
  /**
   * 圆形
   */
  LineEndType["OVAL"] = "oval";
})(LineEndType || (LineEndType = {}));
/**
 * 箭头宽度类型
 */
var LineEndWidthType;
(function (LineEndWidthType) {
  LineEndWidthType["SMALL"] = "sm";
  LineEndWidthType["MIDDLE"] = "med";
  LineEndWidthType["LARGE"] = "lg";
})(LineEndWidthType || (LineEndWidthType = {}));

var generateEndPathMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LineEndType.TRIANGLE, function (options) {
  return generateTrianglePath(options);
}), LineEndType.ARROW, function (options) {
  return generateArrowPath(options);
}), LineEndType.STEALTH, function (options) {
  return generateStealthPath(options);
}), LineEndType.DIAMOND, function (options) {
  return generateDiamondPath(options);
}), LineEndType.OVAL, function (options) {
  return generateOvalPath(options);
}), LineEndType.NONE, function () {
  return null;
});
function generateTrianglePath(options) {
  var point = options.point,
    strokeWidth = options.strokeWidth,
    cos = options.cos,
    sin = options.sin,
    widthTimes = options.widthTimes,
    lengthTimes = options.lengthTimes;
  var originX = point.x;
  var originY = point.y;
  var offsetX = point.x - lengthTimes / 3 * strokeWidth;
  var offsetY = point.y - widthTimes / 2 * strokeWidth;
  var points = [{
    x: offsetX,
    y: offsetY
  }, {
    x: lengthTimes * strokeWidth + offsetX,
    y: widthTimes / 2 * strokeWidth + offsetY
  }, {
    x: offsetX,
    y: widthTimes * strokeWidth + offsetY
  }];
  var pointsAfterRotate = points.map(function (item) {
    var vector = {
      x: item.x - originX,
      y: item.y - originY
    };
    return {
      x: vector.x * cos - vector.y * sin + originX,
      y: vector.y * cos + vector.x * sin + originY
    };
  });
  var svgPath = "M".concat(pointsAfterRotate[0].x, " ").concat(pointsAfterRotate[0].y, " ") + "L".concat(pointsAfterRotate[1].x, " ").concat(pointsAfterRotate[1].y, " ") + "L".concat(pointsAfterRotate[2].x, " ").concat(pointsAfterRotate[2].y, " Z");
  return {
    svgPath: svgPath,
    fillMode: FillMode.NORMAL,
    notStroke: true,
    isLineEndPath: true
  };
}
function generateArrowPath(options) {
  var point = options.point,
    strokeWidth = options.strokeWidth,
    sin = options.sin,
    cos = options.cos,
    widthTimes = options.widthTimes,
    lengthTimes = options.lengthTimes;
  var originX = point.x;
  var originY = point.y;
  var offsetX = point.x - lengthTimes * strokeWidth;
  var offsetY = point.y - widthTimes / 2 * strokeWidth;
  var points = [{
    x: offsetX,
    y: offsetY
  }, {
    x: lengthTimes * strokeWidth + offsetX,
    y: widthTimes / 2 * strokeWidth + offsetY
  }, {
    x: offsetX,
    y: widthTimes * strokeWidth + offsetY
  }];
  var pointsAfterRotate = points.map(function (item) {
    var vector = {
      x: item.x - originX,
      y: item.y - originY
    };
    return {
      x: vector.x * cos - vector.y * sin + originX,
      y: vector.y * cos + vector.x * sin + originY
    };
  });
  var svgPath = "M".concat(pointsAfterRotate[0].x, " ").concat(pointsAfterRotate[0].y, " ") + "L".concat(pointsAfterRotate[1].x, " ").concat(pointsAfterRotate[1].y, " ") + "L".concat(pointsAfterRotate[2].x, " ").concat(pointsAfterRotate[2].y, " ");
  return {
    svgPath: svgPath,
    fillMode: FillMode.NONE,
    notStroke: false,
    lineCap: LineCap.Round,
    isLineEndPath: true
  };
}
function generateStealthPath(options) {
  var point = options.point,
    strokeWidth = options.strokeWidth,
    sin = options.sin,
    cos = options.cos,
    widthTimes = options.widthTimes,
    lengthTimes = options.lengthTimes;
  var originX = point.x;
  var originY = point.y;
  var offsetX = point.x - lengthTimes / 3 * strokeWidth;
  var offsetY = point.y - widthTimes / 2 * strokeWidth;
  var points = [{
    x: offsetX,
    y: offsetY
  }, {
    x: lengthTimes * strokeWidth + offsetX,
    y: widthTimes / 2 * strokeWidth + offsetY
  }, {
    x: offsetX,
    y: widthTimes * strokeWidth + offsetY
  }, {
    x: lengthTimes / 3 * strokeWidth + offsetX,
    y: widthTimes / 2 * strokeWidth + offsetY
  }];
  var pointsAfterRotate = points.map(function (item) {
    var vector = {
      x: item.x - originX,
      y: item.y - originY
    };
    return {
      x: vector.x * cos - vector.y * sin + originX,
      y: vector.y * cos + vector.x * sin + originY
    };
  });
  var svgPath = "M".concat(pointsAfterRotate[0].x, " ").concat(pointsAfterRotate[0].y, " ") + "L".concat(pointsAfterRotate[1].x, " ").concat(pointsAfterRotate[1].y, " ") + "L".concat(pointsAfterRotate[2].x, " ").concat(pointsAfterRotate[2].y, " ") + "L".concat(pointsAfterRotate[3].x, " ").concat(pointsAfterRotate[3].y, " Z");
  return {
    svgPath: svgPath,
    fillMode: FillMode.NORMAL,
    notStroke: true,
    isLineEndPath: true
  };
}
function generateDiamondPath(options) {
  var point = options.point,
    strokeWidth = options.strokeWidth,
    sin = options.sin,
    cos = options.cos,
    widthTimes = options.widthTimes,
    lengthTimes = options.lengthTimes;
  var originX = point.x;
  var originY = point.y;
  var offsetX = point.x;
  var offsetY = point.y - widthTimes / 2 * strokeWidth;
  var points = [{
    x: offsetX,
    y: offsetY
  }, {
    x: lengthTimes / 2 * strokeWidth + offsetX,
    y: widthTimes / 2 * strokeWidth + offsetY
  }, {
    x: offsetX,
    y: widthTimes * strokeWidth + offsetY
  }, {
    x: offsetX - lengthTimes / 2 * strokeWidth,
    y: widthTimes / 2 * strokeWidth + offsetY
  }];
  var pointsAfterRotate = points.map(function (item) {
    var vector = {
      x: item.x - originX,
      y: item.y - originY
    };
    return {
      x: vector.x * cos - vector.y * sin + originX,
      y: vector.y * cos + vector.x * sin + originY
    };
  });
  var svgPath = "M".concat(pointsAfterRotate[0].x, " ").concat(pointsAfterRotate[0].y, " ") + "L".concat(pointsAfterRotate[1].x, " ").concat(pointsAfterRotate[1].y, " ") + "L".concat(pointsAfterRotate[2].x, " ").concat(pointsAfterRotate[2].y, " ") + "L".concat(pointsAfterRotate[3].x, " ").concat(pointsAfterRotate[3].y, " Z");
  return {
    svgPath: svgPath,
    fillMode: FillMode.NORMAL,
    notStroke: true,
    isLineEndPath: true
  };
}
function generateOvalPath(options) {
  var point = options.point,
    strokeWidth = options.strokeWidth,
    widthTimes = options.widthTimes,
    lengthTimes = options.lengthTimes,
    sin = options.sin,
    cos = options.cos;
  var originX = point.x;
  var originY = point.y;
  var offsetX = point.x;
  var offsetY = point.y;
  var radiusX = lengthTimes / 2 * strokeWidth;
  var radiusY = widthTimes / 2 * strokeWidth;
  var angleNeedReverse = cos < 0 && sin < 0 ? -1 : 1;
  var angle = Math.acos(cos) * 180 * angleNeedReverse / Math.PI;
  var startPt = {
    x: offsetX - radiusX,
    y: offsetY
  };
  var middlePt = {
    x: offsetX + radiusX,
    y: offsetY
  };
  var startVector = {
    x: startPt.x - originX,
    y: startPt.y - originY
  };
  var middleVector = {
    x: middlePt.x - originX,
    y: middlePt.y - originY
  };
  var startPtAfterRotate = {
    x: startVector.x * cos - startVector.y * sin + originX,
    y: startVector.y * cos + startVector.x * sin + originY
  };
  var middlePtAfterRotate = {
    x: middleVector.x * cos - middleVector.y * sin + originX,
    y: middleVector.y * cos + middleVector.x * sin + originY
  };
  var svgPath = "M".concat(startPtAfterRotate.x, " ").concat(startPtAfterRotate.y, " ") + "A".concat(radiusX, ",").concat(radiusY, " ").concat(angle, " 1,0 ").concat(middlePtAfterRotate.x, ",").concat(middlePtAfterRotate.y) + "A".concat(radiusX, ",").concat(radiusY, " ").concat(angle, " 1,0 ").concat(startPtAfterRotate.x, ",").concat(startPtAfterRotate.y);
  return {
    svgPath: svgPath,
    fillMode: FillMode.NORMAL,
    notStroke: true,
    isLineEndPath: true
  };
}

var MIN_END_STROKE_WIDTH = 2;

var Command = {
  MoveTo: 'M',
  LineTo: 'L',
  CurveTo: 'C',
  QuadraticCurveTo: 'Q',
  ClosePath: 'Z'
};
var BaseLineEnd = /*#__PURE__*/function () {
  function BaseLineEnd(lineEnd, lineWidth) {
    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var minEndStrokeWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MIN_END_STROKE_WIDTH;
    _classCallCheck(this, BaseLineEnd);
    this.point = {
      x: 0,
      y: 0
    };
    this.update(lineEnd, lineWidth, scale, minEndStrokeWidth);
  }
  return _createClass(BaseLineEnd, [{
    key: "getEndStrokeWidth",
    value: function getEndStrokeWidth() {
      var _ref = this.lineEnd || {},
        lineEndType = _ref.lineEndType,
        lengthType = _ref.lengthType;
      var lineWidth = this.getMultipleTimes(lengthType) * this.strokeWidth;
      switch (lineEndType) {
        case LineEndType.TRIANGLE:
        case LineEndType.STEALTH:
          return lineWidth * 2 / 3;
        case LineEndType.ARROW:
          return lineWidth / 12;
        case LineEndType.DIAMOND:
        case LineEndType.OVAL:
        case LineEndType.NONE:
        default:
          return 0;
      }
    }
  }, {
    key: "update",
    value: function update(lineEnd, lineWidth) {
      var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var minEndStrokeWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MIN_END_STROKE_WIDTH;
      this.lineEnd = lineEnd;
      this.strokeWidth = Math.max(lineWidth, minEndStrokeWidth) / scale;
    }
  }, {
    key: "updateEndPoint",
    value: function updateEndPoint(x, y) {
      this.point.x = x;
      this.point.y = y;
    }
  }, {
    key: "getEndPath",
    value: function getEndPath(svgPath) {
      var _a;
      if (!this.lineEnd || !this.direction && !svgPath) {
        return null;
      }
      var direction = this.direction || this.getEndDirection(svgPath);
      var maxEdge = Math.sqrt(Math.pow(direction.x, 2) + Math.pow(direction.y, 2));
      var sin = direction.y / maxEdge;
      var cos = direction.x / maxEdge;
      var _this$lineEnd = this.lineEnd,
        _this$lineEnd$lineEnd = _this$lineEnd.lineEndType,
        lineEndType = _this$lineEnd$lineEnd === void 0 ? LineEndType.NONE : _this$lineEnd$lineEnd,
        widthType = _this$lineEnd.widthType,
        lengthType = _this$lineEnd.lengthType;
      var options = {
        point: this.point,
        strokeWidth: this.strokeWidth,
        sin: sin,
        cos: cos,
        widthTimes: this.getMultipleTimes(widthType),
        lengthTimes: this.getMultipleTimes(lengthType)
      };
      return (_a = generateEndPathMap[lineEndType]) === null || _a === void 0 ? void 0 : _a.call(generateEndPathMap, options);
    }
  }, {
    key: "updateEndDirection",
    value: function updateEndDirection(direction) {
      this.direction = direction;
    }
  }, {
    key: "getMultipleTimes",
    value: function getMultipleTimes(endWidthType) {
      // 获取不同箭头粗细对应的几倍线宽
      switch (endWidthType) {
        case LineEndWidthType.SMALL:
          return 2;
        case LineEndWidthType.LARGE:
          return 5;
        case LineEndWidthType.MIDDLE:
        default:
          return 3;
      }
    }
  }]);
}();

var EndType;
(function (EndType) {
  EndType[EndType["Head"] = 0] = "Head";
  EndType[EndType["Tail"] = 1] = "Tail";
})(EndType || (EndType = {}));
var PathHandler = /*#__PURE__*/function () {
  function PathHandler(props) {
    _classCallCheck(this, PathHandler);
    this.pathToLineMap = new Map();
    this.segments = props.segments;
    this.endSite = props.endSite;
    this.scale = props.scale;
  }
  /**
   * 该算法整体思路：该算法旨在将任意path的头部/尾部截断箭头大小的长度
   * 主要难点在于贝塞尔曲线在起点/终点变更后，使用解析法无法得到一段新的、与原曲线完全拟合的、长度变化了的贝塞尔曲线
   * 所以将需要变更起点/终点的贝塞尔曲线转为线段来模拟视觉上类似的效果，如果后续发现拟合效果不好可以加大线段的数量来提升拟合精度
   * 箭头方向部分，有三种方案被纳入考虑范围：
   * ① 将截断前的path方向作为最终的箭头方向
   * ② 将截断后尾部的箭头方向作为最终的箭头方向
   * ③ 以起点为例，将截断前的path起点与截断后的path的起点的连线方向作为起点箭头方向
   * 方案①存在的问题是，线条宽度越长，需要截断的长度也就越大，截断后的path方向也就越可能与原path方向差距过大
   * 方案②存在的问题是，截断后的path可能会有多个较为突兀的小段转折，可能导致视觉上与path整体的走势完全不同
   * 而方案③可以保证箭头的尖尖可以完美的指向原来的位置
   * 如何计算需要截断几段path？截断的依据有两个，一个是需要截断的长度，另一个是箭头的方向
   * 在采用方案③的前提下，我们无法在截断完成之前知道截断后的位置，也就是箭头的方向
   * 所以在没有方向的前提下，也就无法得知每条线段在方向上的投影，也就无法判断应该截断到哪里为止
   * 所以不能采用投影的方式来计算箭头方向上的长度，转而使用圆来计算
   * 以起点为例，以起点为圆心，以需要截断的长度为半径画圆，找到转后的线段与该圆的交点，交点即为新path的起点
   * 新起点->旧起点方向即为箭头方向
   */
  /**
   * 计算截断后新路径的入口方法
   * @returns 新路径
   */
  return _createClass(PathHandler, [{
    key: "getNewPathAfterCut",
    value: function getNewPathAfterCut() {
      var endSite = this.endSite;
      if (!endSite) {
        return '';
      }
      if (endSite.head) {
        this.calculateStraightLineDetail(true);
      }
      if (endSite.tail) {
        this.calculateStraightLineDetail(false);
      }
      this.gennerateNewPath(endSite);
      return this.newPath;
    }
    /**
     * 将原始路径转成线段的方法
     * @param points 单个segment
     * @returns 线段组
     */
  }, {
    key: "getPathToStraightLine",
    value: function getPathToStraightLine(points) {
      var lineCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      if (points.cmd === Command.CurveTo || points.cmd === Command.QuadraticCurveTo) {
        // 只有第一段命令是moveTo，没有startX与startY，不会进到这里来
        var startPt = {
          x: points.startX,
          y: points.startY
        };
        var endPt = {
          x: points.x,
          y: points.y
        };
        var controlPt1;
        var controlPt2;
        if (points.cmd === Command.QuadraticCurveTo) {
          // 需要将二次贝塞尔曲线升次到三次贝塞尔曲线来统一处理
          controlPt1 = {
            x: (points.startX + 2 * points.x1) / 3,
            y: (points.startY + 2 * points.y1) / 3
          };
          controlPt2 = {
            x: (points.x + 2 * points.x1) / 3,
            y: (points.y + 2 * points.y1) / 3
          };
        } else {
          controlPt1 = {
            x: points.x1,
            y: points.y1
          };
          controlPt2 = {
            x: points.x2,
            y: points.y2
          };
        }
        return this.simulateBezierByStraightLine(startPt, endPt, controlPt1, controlPt2, lineCount);
      }
      if (points.cmd === Command.LineTo || points.cmd === Command.ClosePath) {
        return [{
          startX: points.startX,
          startY: points.startY,
          x: points.x,
          y: points.y
        }];
      }
      return [];
    }
    /**
     * 起名好难。。该方法对segments进行循环，每个segment是一段原始路径，将该段path转成线段
     * 然后对转出的线段组进行循环，找到与圆相交的那个线段并记录到map中，待后续使用
     * @param isHead 头尾的循环方向是相反的，需要参数来标识
     */
  }, {
    key: "calculateStraightLineDetail",
    value: function calculateStraightLineDetail(isHead) {
      var segments = this.segments;
      if (isHead) {
        for (var i = 0; i < segments.length; i++) {
          var straightLines = this.getPathToStraightLine(segments[i]);
          if (straightLines === null || straightLines === void 0 ? void 0 : straightLines.length) {
            var needBreak = this.getOriginPathToLineDetail(straightLines, i, isHead);
            if (needBreak) {
              break;
            }
          }
        }
      } else {
        for (var _i = segments.length - 1; _i >= 0; _i--) {
          var _straightLines = this.getPathToStraightLine(segments[_i]);
          if (_straightLines === null || _straightLines === void 0 ? void 0 : _straightLines.length) {
            var _needBreak = this.getOriginPathToLineDetail(_straightLines, _i, isHead);
            if (_needBreak) {
              break;
            }
          }
        }
      }
    }
    /**
     * 对模拟出的线段进行循环，判断当前贝塞尔曲线转出的线段是否都在
     * 以端点为圆心、以需要截断的距离为半径的圆内
     * 如果都在，说明该条贝赛尔曲线的长度不够，需要再将下一段贝塞尔也转成线段
     * @param straightLines 模拟出的线段组
     * @param i 外层循环的index
     * @param isHead 头尾循环方向不一致，标志位
     * @returns 找到目标线段后需要跳出全部循环，标志位
     */
  }, {
    key: "getOriginPathToLineDetail",
    value: function getOriginPathToLineDetail(straightLines, i, isHead) {
      var endSite = this.endSite;
      if (!endSite) {
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      var radius = isHead ? endSite.head : endSite.tail;
      if (isHead) {
        for (var j = 0; j < straightLines.length; j++) {
          var needBreak = this.getLineCrossCircle(straightLines, i, j, radius, isHead);
          if (needBreak) {
            return true;
          }
        }
      } else {
        for (var _j = straightLines.length - 1; _j >= 0; _j--) {
          var _needBreak2 = this.getLineCrossCircle(straightLines, i, _j, radius, isHead);
          if (_needBreak2) {
            return true;
          }
        }
      }
      return false;
    }
    /**
     * 仅处理头部/尾部需要截断部分的path的方法，将之前记录的相交的线段转换成截断后的path
     * @param endInfo 存储在map中的与圆相交的线段信息
     * @param endSite 需要截断的长度
     * @param isHead 头部需要先截断、再继续画，尾部需要先画、再截断，标识位
     * @param hasCutted 当前path是否已经经过了一次截断
     */
  }, {
    key: "cutExtraPath",
    value: function cutExtraPath(endInfo, endSite, isHead, hasCutted) {
      var _this = this;
      var segments = this.segments,
        scale = this.scale;
      // 计算第一条两个端点不都在圆内的线段与该圆的交点，以该点作为新的起点
      var preX = endInfo.preX,
        preY = endInfo.preY,
        currentX = endInfo.currentX,
        currentY = endInfo.currentY,
        lines = endInfo.lines;
      // 圆心
      var coc = isHead ? segments[0] : segments[segments.length - 1];
      // 半径
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      var radius = (isHead ? endSite.head : endSite.tail) / scale;
      var intersections = this.getIntersectionOfCircleAndLine(radius, coc.x, coc.y, {
        x: preX,
        y: preY
      }, {
        x: currentX,
        y: currentY
      });
      if (intersections.length === 1) {
        // 一个交点认为与圆相切
        var needCut = isHead;
        var isStraightLine = lines.length === 1;
        lines.forEach(function (line) {
          if (line.x === currentX && line.y === currentY) {
            needCut = !needCut;
            if (!isHead) {
              var subPath = _this.newPath.split('L');
              if (isStraightLine && subPath.length === 2) {
                _this.newPath = "".concat(subPath[0], "L ").concat(intersections[0].x, " ").concat(intersections[0].y);
              } else {
                _this.newPath = "".concat(_this.newPath, " L ").concat(intersections[0].x, " ").concat(intersections[0].y);
              }
              return;
            }
          }
          if (!needCut) {
            if (isHead) {
              if (_this.newPath === "M ".concat(segments[0].x, " ").concat(segments[0].y)) {
                _this.newPath = "M ".concat(intersections[0].x, " ").concat(intersections[0].y, " L ").concat(currentX, " ").concat(currentY);
              } else {
                _this.newPath = "".concat(_this.newPath, " L ").concat(line.x, " ").concat(line.y);
              }
            } else {
              // 如果头部已经截断过了，那么这里不需要将剩余不需要截断的部分重新添加一遍
              if (!hasCutted) {
                _this.newPath = "".concat(_this.newPath, " L ").concat(line.x, " ").concat(line.y);
              }
            }
          }
        });
      } else if (intersections.length === 2) {
        // 两个交点去找那个在线段内部的点
        intersections.forEach(function (intersection) {
          var maxX = Math.max(preX, currentX);
          var minX = Math.min(preX, currentX);
          var maxY = Math.max(preY, currentY);
          var minY = Math.min(preY, currentY);
          var ptx = intersection.x;
          var pty = intersection.y;
          if (ptx <= maxX && ptx >= minX && pty <= maxY && pty >= minY) {
            var _needCut = isHead;
            var _isStraightLine = lines.length === 1;
            // eslint-disable-next-line complexity
            lines.forEach(function (line) {
              var _a;
              // 当line.x === currentX && line.y === currentY时认为该条直线与圆相交
              if (line.x === currentX && line.y === currentY) {
                _needCut = !_needCut;
                if (!isHead) {
                  /**
                   * 当截断尾部时，如果已生成出的path是直线且原path也是直线且头部进行过截断了
                   * 由于头部在截断时额外添加了一个lineTo
                   * 那么需要path的尾部调整为当前直线的尾部，如果不是的话直接添加即可
                   */
                  var subPath = _this.newPath.split('L');
                  if (_isStraightLine && segments[1].cmd === Command.LineTo && segments.length === 2 && ((_a = _this.endSite) === null || _a === void 0 ? void 0 : _a.head)) {
                    _this.newPath = "".concat(subPath[0], "L ").concat(ptx, " ").concat(pty);
                  } else {
                    _this.newPath = "".concat(_this.newPath, " L ").concat(ptx, " ").concat(pty);
                  }
                  return;
                }
              }
              if (!_needCut) {
                if (isHead) {
                  // 如果当前是初始的起点，需要重写起点，重写起点后需要额外添加一个lineTo以防止原path只有一段的情况导致path长度为0
                  if (_this.newPath === "M ".concat(segments[0].x, " ").concat(segments[0].y)) {
                    _this.newPath = "M ".concat(ptx, " ").concat(pty, " L ").concat(currentX, " ").concat(currentY);
                  } else {
                    _this.newPath = "".concat(_this.newPath, " L ").concat(line.x, " ").concat(line.y);
                  }
                } else {
                  // 如果头部已经截断过了，那么这里不需要将剩余不需要截断的部分重新添加一遍
                  if (!hasCutted) {
                    _this.newPath = "".concat(_this.newPath, " L ").concat(line.x, " ").concat(line.y);
                  }
                }
              }
            });
          }
        });
      }
    }
    /**
     * 工具方法，将原segments中的命令一一对应成path
     * @param segment 单个segment
     */
  }, {
    key: "turnSegementsToPath",
    value: function turnSegementsToPath(segment) {
      if (segment.cmd === Command.CurveTo) {
        this.newPath = "".concat(this.newPath, " ").concat(segment.cmd, " ").concat(segment.x1, " ").concat(segment.y1, ", ").concat(segment.x2, " ").concat(segment.y2, ", ").concat(segment.x, " ").concat(segment.y);
      } else if (segment.cmd === Command.QuadraticCurveTo) {
        this.newPath = "".concat(this.newPath, " ").concat(segment.cmd, " ").concat(segment.x1, " ").concat(segment.y1, ", ").concat(segment.x, " ").concat(segment.y);
      } else if (segment.cmd === Command.LineTo) {
        this.newPath = "".concat(this.newPath, " ").concat(segment.cmd, " ").concat(segment.x, " ").concat(segment.y);
      }
    }
    /**
     * 判断原路径是否为一条lineTo
     * @param index 循环的segment的index
     * @param headInfo 记录的头部信息
     * @param tailInfo 记录的尾部信息
     */
  }, {
    key: "isSamePathIndex",
    value: function isSamePathIndex(index, headInfo, tailInfo) {
      return index === (headInfo === null || headInfo === void 0 ? void 0 : headInfo.index) && index === (tailInfo === null || tailInfo === void 0 ? void 0 : tailInfo.index);
    }
    /**
     * 生成新路径的入口方法
     * @param endSite 需要截断头部和尾部的宽度
     */
  }, {
    key: "gennerateNewPath",
    value: function gennerateNewPath(endSite) {
      var _this2 = this;
      var segments = this.segments;
      var headInfo = this.pathToLineMap.get(EndType.Head);
      var tailInfo = this.pathToLineMap.get(EndType.Tail);
      segments.forEach(function (segment, index) {
        if (index === 0) {
          _this2.newPath = "M ".concat(segment.x, " ").concat(segment.y);
        } else if (_this2.isSamePathIndex(index, headInfo, tailInfo)) {
          // 当两端需要截断的线段是同一条时，这里头部和尾部都需截断
          _this2.cutExtraPath(headInfo, endSite, true);
          _this2.cutExtraPath(tailInfo, endSite, false, true);
        } else if (index === (headInfo === null || headInfo === void 0 ? void 0 : headInfo.index)) {
          // 头部部分的截断
          _this2.cutExtraPath(headInfo, endSite, true);
        } else if (index === (tailInfo === null || tailInfo === void 0 ? void 0 : tailInfo.index)) {
          // 尾部部分的截断
          _this2.cutExtraPath(tailInfo, endSite, false);
        } else if (index >= ((headInfo === null || headInfo === void 0 ? void 0 : headInfo.index) || 0) && index <= ((tailInfo === null || tailInfo === void 0 ? void 0 : tailInfo.index) || segments.length - 1)) {
          _this2.turnSegementsToPath(segment);
        }
      });
    }
    /**
     * 获取与圆相交的线段的方法，原理是判断两个端是否一个在圆内、另一个在圆外
     * @param straightLines 转换出的线段组
     * @param i 最外层循环的index，目的是作为后续查找结果的key
     * @param j 内层循环的index
     * @param radius 半径
     * @param isHead 是否是头部的标志位
     * @returns 找到目标后需打破所有循环，标志位
     */
  }, {
    key: "getLineCrossCircle",
    value: function getLineCrossCircle(straightLines, i, j, radius, isHead) {
      var segments = this.segments,
        scale = this.scale;
      var line = straightLines[j];
      var preX = line.startX;
      var preY = line.startY;
      var currentX = line.x;
      var currentY = line.y;
      // center of circle
      var coc = isHead ? segments[0] : segments[segments.length - 1];
      var distance1 = Math.pow(Math.pow(coc.x - preX, 2) + Math.pow(coc.y - preY, 2), 0.5) * scale;
      var distance2 = Math.pow(Math.pow(coc.x - currentX, 2) + Math.pow(coc.y - currentY, 2), 0.5) * scale;
      if (distance1 >= radius || distance2 >= radius) {
        this.pathToLineMap.set(isHead ? EndType.Head : EndType.Tail, {
          preX: preX,
          preY: preY,
          currentX: currentX,
          currentY: currentY,
          index: i,
          lines: straightLines
        });
        return true;
      }
      return false;
    }
    /**
     * 三阶贝塞尔曲线关于t的参数方程
     * @param startPt 起点
     * @param endPt 终点
     * @param controlPt1 控制点1
     * @param controlPt2 控制点2
     * @param t 取值范围为0-1，可以理解为比例
     * @returns 该比例时在该曲线上的点的位置
     */
  }, {
    key: "getBezierCoordinates",
    value: function getBezierCoordinates(startPt, endPt, controlPt1, controlPt2, t) {
      var t2 = Math.pow(t, 2);
      var t3 = Math.pow(t, 3);
      var mt = 1 - t;
      var mt2 = Math.pow(mt, 2);
      var mt3 = Math.pow(mt, 3);
      var x = startPt.x * mt3 + 3 * controlPt1.x * mt2 * t + 3 * controlPt2.x * mt * t2 + endPt.x * t3;
      var y = startPt.y * mt3 + 3 * controlPt1.y * mt2 * t + 3 * controlPt2.y * mt * t2 + endPt.y * t3;
      return {
        x: x,
        y: y
      };
    }
    /**
     * 用若干条线段模拟出三阶贝塞尔曲线
     * @param startPt 起点
     * @param endPt 终点
     * @param controlPt1 控制点1
     * @param controlPt2 控制点2
     * @param lineCount 线段的数量,数量越多模拟的越精确
     * @returns 若干条线段的终点，上一条直线的终点也是下一条线段的起点
     */
  }, {
    key: "simulateBezierByStraightLine",
    value: function simulateBezierByStraightLine(startPt, endPt, controlPt1, controlPt2, lineCount) {
      var step = 1 / lineCount;
      var coordinates = [];
      var _this$getBezierCoordi = this.getBezierCoordinates(startPt, endPt, controlPt1, controlPt2, 0),
        preX = _this$getBezierCoordi.x,
        preY = _this$getBezierCoordi.y;
      for (var i = 1; i <= lineCount; i++) {
        var t = i * step;
        var _this$getBezierCoordi2 = this.getBezierCoordinates(startPt, endPt, controlPt1, controlPt2, t),
          x = _this$getBezierCoordi2.x,
          y = _this$getBezierCoordi2.y;
        coordinates.push({
          startX: preX,
          startY: preY,
          x: x,
          y: y
        });
        preX = x;
        preY = y;
      }
      return coordinates;
    }
    /**
     * 计算圆与直线的交点
     * 设线段的两个端点分别是P1(x1,y1)和P2(x2,y2)，圆的圆心在P3(x3,y3)，半径为r，那么如果有交点P(x,y)的话
     * 则P=P1+u(P2−P1) 其中P为向量，u在0-1之间，然后联立线段的参数方程与圆的方程得一元二次方程
     * Au²+Bu+C = 0
     * @param r 半径
     * @param cx 圆心x坐标
     * @param cy 圆心y坐标
     * @param pt1 线段的一端
     * @param pt2 线段的另一端
     * @return 交点坐标，可能为0/1/2个，代表直线与圆不相交/相切/相交
     */
  }, {
    key: "getIntersectionOfCircleAndLine",
    value: function getIntersectionOfCircleAndLine(r, cx, cy, pt1, pt2) {
      if (pt1.x === pt2.x && pt1.y === pt2.y) {
        return [{
          x: pt1.x,
          y: pt1.y
        }];
      }
      var x1 = pt1.x;
      var y1 = pt1.y;
      var x2 = pt2.x;
      var y2 = pt2.y;
      var x3 = cx;
      var y3 = cy;
      var A = Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2);
      var B = 2 * ((x2 - x1) * (x1 - x3) + (y2 - y1) * (y1 - y3));
      var C = Math.pow(x3, 2) + Math.pow(y3, 2) + Math.pow(x1, 2) + Math.pow(y1, 2) - 2 * (x1 * x3 + y1 * y3) - Math.pow(r, 2);
      // 判别式
      var delta = Math.pow(B, 2) - 4 * (A * C);
      if (delta < 0) {
        return [];
      }
      if (delta === 0) {
        var u = -B / (2 * A);
        return [{
          x: x1 + u * (x2 - x1),
          y: y1 + u * (y2 - y1)
        }];
      }
      var u1 = (-B + Math.pow(delta, 0.5)) / (2 * A);
      var u2 = (-B - Math.pow(delta, 0.5)) / (2 * A);
      return [{
        x: x1 + u1 * (x2 - x1),
        y: y1 + u1 * (y2 - y1)
      }, {
        x: x1 + u2 * (x2 - x1),
        y: y1 + u2 * (y2 - y1)
      }];
    }
  }]);
}();

var CompoundPath = /*#__PURE__*/function () {
  function CompoundPath(path, strokeStyle) {
    var _this = this;
    _classCallCheck(this, CompoundPath);
    this.getCompoundPath = function () {
      return _this.compoundedPath;
    };
    var _strokeStyle$compound = strokeStyle.compoundType,
      compoundType = _strokeStyle$compound === void 0 ? CompoundType.SINGLE : _strokeStyle$compound,
      isOutsizeBorder = strokeStyle.isOutsizeBorder,
      _strokeStyle$lineWidt = strokeStyle.lineWidth,
      lineWidth = _strokeStyle$lineWidt === void 0 ? 1 : _strokeStyle$lineWidt;
    this.path = path;
    this.compoundInfo = this.getCompoundInfo(compoundType, isOutsizeBorder);
    this.lineWidth = lineWidth;
    this.generateCompoundPath();
  }
  /**
   * 返回的新path中，right/middle/left为新计算的path，不承担填充的责任
   * base为原path，可能有宽度可能无宽度，有无宽度取决于复合类型，承担填充的责任
   */
  return _createClass(CompoundPath, [{
    key: "generateCompoundPath",
    value: function generateCompoundPath() {
      var _this2 = this;
      var pathSegments = new SvgGraphics(this.path.svgPath).segments;
      var splitedPathSegments = this.getSplitMovePath(pathSegments);
      var rLinesArray = [];
      var lLinesArray = [];
      var mLinesArray = [];
      // 一段path中可能存在多个moveto命令，拆分后分别处理，最后合并成一个path
      splitedPathSegments.forEach(function (segments) {
        var straightLines = _this2.turnPathSegmentsToStraightLine(segments);
        var _this2$getThreeLines = _this2.getThreeLines(straightLines),
          rLines = _this2$getThreeLines.rLines,
          lLines = _this2$getThreeLines.lLines,
          mLines = _this2$getThreeLines.mLines;
        rLinesArray.push(rLines);
        lLinesArray.push(lLines);
        mLinesArray.push(mLines);
      });
      this.compoundedPath = this.getNewPath(rLinesArray, lLinesArray, mLinesArray);
    }
    /**
     * 将segments按moveto命令分割为多个segments数组
     * @returns
     */
  }, {
    key: "getSplitMovePath",
    value: function getSplitMovePath(pathSegments) {
      var result = [];
      var temp = [];
      pathSegments.forEach(function (item) {
        if (item.cmd === Command.MoveTo) {
          if (temp.length > 0) {
            result.push(temp);
            temp = [];
          }
          temp.push(item);
        } else {
          temp.push(item);
        }
      });
      if (temp.length > 0) {
        result.push(temp);
      }
      return result;
    }
    /**
     * 对转换出的每条线段，做其左手方向与右手方向的两条平行线，对每个方向而言，以相邻两条线段的平行线的交点作为一端的端点
     * 则对n条线段的一个方向而言，可有n条平行线，有n-1（非闭合曲线）/n(闭合曲线)个平行线交点，连接所有交点即为目标曲线
     */
  }, {
    key: "getThreeLines",
    value: function getThreeLines(straightLines) {
      var _this3 = this;
      var _a, _b, _c;
      var rLength = (((_a = this.compoundInfo.right) === null || _a === void 0 ? void 0 : _a.distance) || 0) * this.lineWidth / (this.path.scaleX || 1);
      var lLength = (((_b = this.compoundInfo.left) === null || _b === void 0 ? void 0 : _b.distance) || 0) * this.lineWidth / (this.path.scaleX || 1);
      var mLength = (((_c = this.compoundInfo.middle) === null || _c === void 0 ? void 0 : _c.distance) || 0) * this.lineWidth / (this.path.scaleX || 1);
      var rLines = [];
      var lLines = [];
      var mLines = [];
      var isCloseStraightLines = this.isCloseStraightLines(straightLines);
      straightLines.forEach(function (straightLine, index) {
        // 一些图形会出现重复的路径命令，很奇怪，跳过
        // 还有SNIP_DIAG_RECT这个智障图形会在倒数第二条命令手动lineto回起点再z一下，会错误的命中这里，不知道怎么解决，也不应该在这解决
        if (Math.abs(straightLine.startX - straightLine.x) < 5e-2 && Math.abs(straightLine.startY - straightLine.y) < 5e-2) {
          return;
        }
        // 首尾向量
        var MN = {
          x: straightLine.x - straightLine.startX,
          y: straightLine.y - straightLine.startY
        };
        // 向量MN的长度
        var MN_L = Math.pow(Math.pow(MN.x, 2) + Math.pow(MN.y, 2), 0.5);
        // MN的单位向量
        var u_MN = {
          x: 1 / MN_L * MN.x,
          y: 1 / MN_L * MN.y
        };
        var isLastLine = index === straightLines.length - 1;
        // 找垂直向量时的简易方法，即与向量(a,b)垂直的向量为(-b,a)和(b,-a)
        // 右手方向的处理
        if (_this3.compoundInfo.right) {
          // 垂直于MN的单位向量（右手方向）
          var u_R = {
            x: u_MN.y,
            y: -1 * u_MN.x
          };
          _this3.getNewLines(u_R, straightLine, rLength, rLines, isLastLine, isCloseStraightLines);
        }
        // 左手方向的处理
        if (_this3.compoundInfo.left) {
          // 垂直于MN的单位向量（左手方向）
          var u_L = {
            x: -1 * u_MN.y,
            y: u_MN.x
          };
          _this3.getNewLines(u_L, straightLine, lLength, lLines, isLastLine, isCloseStraightLines);
        }
        // 中间的路径借用右手方向向量，配置信息也是根据右手算出来的
        if (_this3.compoundInfo.middle) {
          // 垂直于MN的单位向量（右手方向）
          var _u_R = {
            x: u_MN.y,
            y: -1 * u_MN.x
          };
          _this3.getNewLines(_u_R, straightLine, mLength, mLines, isLastLine, isCloseStraightLines);
        }
      });
      return {
        rLines: rLines,
        lLines: lLines,
        mLines: mLines
      };
    }
  }, {
    key: "getNewLines",
    value: function getNewLines(unitVector,
    // 该方向上的单位向量
    straightLine,
    // 本段线段
    length,
    // 偏移的长度
    lines,
    // 结果数组
    isLastLine,
    // 是否是最后一段直线
    isCloseStraightLines) {
      // 起点
      var start = {
        x: unitVector.x * length + straightLine.startX,
        y: unitVector.y * length + straightLine.startY
      };
      // 终点
      var end = {
        x: unitVector.x * length + straightLine.x,
        y: unitVector.y * length + straightLine.y
      };
      if (lines.length) {
        var lastLine = lines[lines.length - 1];
        var _this$getIntersectPoi = this.getIntersectPointOfLines(start.x, start.y, end.x, end.y, lastLine.startX, lastLine.startY, lastLine.x, lastLine.y),
          x = _this$getIntersectPoi.x,
          y = _this$getIntersectPoi.y;
        // 取交点，将上一段的终点与本段的起点调整为交点
        if (x && y) {
          // 经过验证，判断是否有交点的效果不是非常理想，再加一个交点与原来之间的两点的距离与线宽之间的长度的判断
          var lastNewlineLength = this.getDistanceBetween2Points(lastLine.x, lastLine.y, x, y);
          var currentNewLineLength = this.getDistanceBetween2Points(start.x, start.y, x, y);
          var twoLineWidth = 2 * this.lineWidth / (this.path.scaleX || 1);
          if (lastNewlineLength < twoLineWidth && currentNewLineLength < twoLineWidth) {
            // 当调整过的交点与调整前的两点之间的距离小于两倍线宽时才认为是有效的点
            lastLine.x = x;
            lastLine.y = y;
            start.x = x;
            start.y = y;
          }
        }
      }
      // 若是闭合图形，最后一段则与第一段取交点并调整
      if (isLastLine && isCloseStraightLines) {
        var firstLine = lines[0];
        var _this$getIntersectPoi2 = this.getIntersectPointOfLines(start.x, start.y, end.x, end.y, firstLine.startX, firstLine.startY, firstLine.x, firstLine.y),
          _x = _this$getIntersectPoi2.x,
          _y = _this$getIntersectPoi2.y;
        if (_x && _y) {
          var firstNewLineLength = this.getDistanceBetween2Points(firstLine.startX, firstLine.startY, _x, _y);
          var _currentNewLineLength = this.getDistanceBetween2Points(end.x, end.y, _x, _y);
          var _twoLineWidth = 2 * this.lineWidth / (this.path.scaleX || 1);
          if (firstNewLineLength < _twoLineWidth && _currentNewLineLength < _twoLineWidth) {
            firstLine.startX = _x;
            firstLine.startY = _y;
            end.x = _x;
            end.y = _y;
          }
        }
      }
      lines.push({
        x: end.x,
        y: end.y,
        startX: start.x,
        startY: start.y
      });
    }
    /**
     * 求两直线交点
     * @param 两直线上的四点坐标
     */
  }, {
    key: "getIntersectPointOfLines",
    value: function getIntersectPointOfLines(x1, y1, x2, y2, x3, y3, x4, y4) {
      var _this$generalEquation = this.generalEquation(x1, y1, x2, y2),
        A1 = _this$generalEquation.A,
        B1 = _this$generalEquation.B,
        C1 = _this$generalEquation.C;
      var _this$generalEquation2 = this.generalEquation(x3, y3, x4, y4),
        A2 = _this$generalEquation2.A,
        B2 = _this$generalEquation2.B,
        C2 = _this$generalEquation2.C;
      var m = A1 * B2 - A2 * B1;
      /**
       * 此处本来应该用两条直线的斜率是否相等来判断是否有交点，但
       * ①某些自由曲线会出现两条斜率很接近的相邻两条直线
       * ②接近垂直时，斜率的值会被放大
       * 若仍然用相等来判断，则会出现距离非常远的交点，不符合预期，转而取较小值，两个值是随便拍的，发现badcase可以调整
       */
      if (Math.abs(m / (B1 * B2)) < 3e-2 || Math.abs(B1) < 5e-2 && Math.abs(B2) < 5e-2) {
        // 无交点
        return {
          x: undefined,
          y: undefined
        };
      }
      return {
        x: (C2 * B1 - C1 * B2) / m,
        y: (C1 * A2 - C2 * A1) / m
      };
    }
    /**
     * 求直线的一般式方程
     * @param 直线上的两点坐标
     */
  }, {
    key: "generalEquation",
    value: function generalEquation(x1, y1, x2, y2) {
      var A = y2 - y1;
      var B = x1 - x2;
      var C = x2 * y1 - x1 * y2;
      return {
        A: A,
        B: B,
        C: C
      };
    }
    /**
     * 求两点之间的长度
     * @param 两点坐标
     */
  }, {
    key: "getDistanceBetween2Points",
    value: function getDistanceBetween2Points(x1, y1, x2, y2) {
      return Math.pow(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2), 0.5);
    }
  }, {
    key: "getTDArrayLength",
    value: function getTDArrayLength(TDArray) {
      return TDArray.reduce(function (sum, lines) {
        return sum + ((lines === null || lines === void 0 ? void 0 : lines.length) || 0);
      }, 0);
    }
  }, {
    key: "getSvgPathFromLines",
    value: function getSvgPathFromLines(linesArray) {
      var _this4 = this;
      return linesArray.reduce(function (pathString, lines) {
        return "".concat(pathString, " ").concat(_this4.turnStraightLineToPath(lines)).trim();
      }, '');
    }
  }, {
    key: "getNewPath",
    value: function getNewPath(rLinesArray, lLinesArray, mLinesArray) {
      var paths = [];
      paths.push(Object.assign(Object.assign({}, this.path), {
        isCompoundPath: true,
        needFill: true,
        widthPercent: this.compoundInfo.base.width
      }));
      if (this.getTDArrayLength(rLinesArray)) {
        var svgPath = this.getSvgPathFromLines(rLinesArray);
        paths.push(Object.assign(Object.assign({}, this.path), {
          svgPath: svgPath,
          isCompoundPath: true,
          widthPercent: this.compoundInfo.right.width
        }));
      }
      if (this.getTDArrayLength(mLinesArray)) {
        var _svgPath = this.getSvgPathFromLines(mLinesArray);
        paths.push(Object.assign(Object.assign({}, this.path), {
          svgPath: _svgPath,
          isCompoundPath: true,
          widthPercent: this.compoundInfo.middle.width
        }));
      }
      if (this.getTDArrayLength(lLinesArray)) {
        var _svgPath2 = this.getSvgPathFromLines(lLinesArray);
        paths.push(Object.assign(Object.assign({}, this.path), {
          svgPath: _svgPath2,
          isCompoundPath: true,
          widthPercent: this.compoundInfo.left.width
        }));
      }
      return paths;
    }
  }, {
    key: "turnStraightLineToPath",
    value: function turnStraightLineToPath(lines) {
      var svgPath = '';
      lines.forEach(function (line, index) {
        if (index === 0) {
          svgPath = "M ".concat(line.startX, " ").concat(line.startY, " L ").concat(line.x, " ").concat(line.y);
        } else if (index === lines.length - 1 && line.x === lines[0].startX && line.y === lines[0].startY) {
          // 如果不使用z而是用lineTo连过去的话，会有1/2个边框宽度的正方形缺失
          svgPath = "".concat(svgPath, " Z");
        } else {
          svgPath = "".concat(svgPath, " L ").concat(line.x, " ").concat(line.y);
        }
      });
      return svgPath;
    }
  }, {
    key: "turnPathSegmentsToStraightLine",
    value: function turnPathSegmentsToStraightLine(pathSegments) {
      var scale = this.path.scaleX || 1;
      var pathHandler = new PathHandler({
        segments: pathSegments,
        scale: scale
      });
      var straightLines = [];
      pathSegments.forEach(function (pathSegment) {
        var straightLine = pathHandler.getPathToStraightLine(pathSegment, 30);
        straightLine.forEach(function (item) {
          straightLines.push(item);
        });
      });
      return straightLines;
    }
  }, {
    key: "getCompoundInfo",
    value: function getCompoundInfo(compoundType, isOutsizeBorder) {
      if (isOutsizeBorder) {
        switch (compoundType) {
          case CompoundType.DOUBLE:
            return {
              right: {
                distance: 5 / 6,
                width: 1 / 3
              },
              left: {
                distance: -1 / 6,
                width: 1 / 3
              },
              base: {
                distance: 0,
                width: 0
              }
            };
          case CompoundType.THICKTHIN:
            return {
              right: {
                distance: 7 / 10,
                width: 3 / 5
              },
              left: {
                distance: -1 / 10,
                width: 1 / 5
              },
              base: {
                distance: 0,
                width: 0
              }
            };
          case CompoundType.THINTHICK:
            return {
              right: {
                distance: 9 / 10,
                width: 1 / 5
              },
              left: {
                distance: -3 / 10,
                width: 3 / 5
              },
              base: {
                distance: 0,
                width: 0
              }
            };
          case CompoundType.TRIPLE:
            return {
              right: {
                distance: 11 / 12,
                width: 1 / 6
              },
              middle: {
                distance: 1 / 2,
                width: 1 / 3
              },
              left: {
                distance: -1 / 12,
                width: 1 / 6
              },
              base: {
                distance: 0,
                width: 0
              }
            };
          default:
            return {
              right: {
                distance: 1 / 2,
                width: 1
              },
              base: {
                distance: 0,
                width: 0
              }
            };
        }
      }
      switch (compoundType) {
        case CompoundType.DOUBLE:
          return {
            right: {
              distance: 1 / 3,
              width: 1 / 3
            },
            left: {
              distance: 1 / 3,
              width: 1 / 3
            },
            base: {
              distance: 0,
              width: 0
            }
          };
        case CompoundType.THICKTHIN:
          return {
            right: {
              distance: 1 / 5,
              width: 3 / 5
            },
            left: {
              distance: 2 / 5,
              width: 1 / 5
            },
            base: {
              distance: 0,
              width: 0
            }
          };
        case CompoundType.THINTHICK:
          return {
            right: {
              distance: 2 / 5,
              width: 1 / 5
            },
            left: {
              distance: 1 / 5,
              width: 3 / 5
            },
            base: {
              distance: 0,
              width: 0
            }
          };
        case CompoundType.TRIPLE:
          return {
            right: {
              distance: 5 / 12,
              width: 1 / 6
            },
            left: {
              distance: 5 / 12,
              width: 1 / 6
            },
            base: {
              distance: 0,
              width: 1 / 3
            }
          };
        default:
          return {
            base: {
              distance: 0,
              width: 1
            }
          };
      }
    }
  }, {
    key: "isCloseStraightLines",
    value: function isCloseStraightLines(straightLines) {
      var lastIndex = straightLines.length - 1;
      return straightLines[lastIndex].x === straightLines[0].startX && straightLines[lastIndex].y === straightLines[0].startY;
    }
  }]);
}();

var BaseGraphics = /*#__PURE__*/function () {
  function BaseGraphics(model) {
    _classCallCheck(this, BaseGraphics);
    this.model = model;
  }
  return _createClass(BaseGraphics, [{
    key: "update",
    value: function update(model) {
      this.model = model;
    }
    /**
     * 更新控制点信息
     */
  }, {
    key: "updateControlValues",
    value: function updateControlValues(controlValues) {
      var _a;
      // 传入 controlValues 时优先使用传入值更新
      if (controlValues) {
        this.controlValues = controlValues;
        return;
      }
      if (((_a = this.model.controlValues) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        this.controlValues = this.model.controlValues;
      } else {
        this.controlValues = this.getDefaultControlValues();
      }
    }
    /**
     * 获取控制点数据信息
     */
  }, {
    key: "getDefaultControlValues",
    value: function getDefaultControlValues() {
      return [];
    }
    /**
     * 获取控制点位置信息，用于绘制控制点
     */
  }, {
    key: "getControlPoints",
    value: function getControlPoints() {
      return [];
    }
    /**
     * 获取连接线连接点信息
     */
  }, {
    key: "getConnectionPoints",
    value: function getConnectionPoints(renderWidth, renderHeight) {
      var width = renderWidth !== null && renderWidth !== void 0 ? renderWidth : this.model.width;
      var height = renderHeight !== null && renderHeight !== void 0 ? renderHeight : this.model.height;
      return [{
        x: width / 2,
        y: 0
      }, {
        x: 0,
        y: height / 2
      }, {
        x: width / 2,
        y: height
      }, {
        x: width,
        y: height / 2
      }];
    }
    /**
     * 获取可包裹形状的矩形区域的信息
     */
  }, {
    key: "getShapeWrapRect",
    value: function getShapeWrapRect() {
      var _this$model = this.model,
        width = _this$model.width,
        height = _this$model.height;
      return {
        left: 0,
        top: 0,
        width: width,
        height: height
      };
    }
    /**
     * 获取复合类型的边框/线条的新path
     */
  }, {
    key: "getPathWithCompoundType",
    value: function getPathWithCompoundType(paths, strokeStyle) {
      var _strokeStyle$compound = strokeStyle.compoundType,
        compoundType = _strokeStyle$compound === void 0 ? CompoundType.SINGLE : _strokeStyle$compound,
        isOutsizeBorder = strokeStyle.isOutsizeBorder;
      if (compoundType === CompoundType.SINGLE && !isOutsizeBorder) {
        return paths;
      }
      var newPaths = [];
      paths.forEach(function (path) {
        if (path.isLineEndPath) {
          newPaths.push(path);
          return;
        }
        path.segments = undefined;
        var compoundedPath = new CompoundPath(path, strokeStyle).getCompoundPath();
        newPaths.push.apply(newPaths, _toConsumableArray(compoundedPath));
      });
      return newPaths;
    }
  }]);
}();

function _callSuper$j(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$j() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$j() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$j = function _isNativeReflectConstruct() { return !!t; })(); }
var HeadEnd = /*#__PURE__*/function (_BaseLineEnd) {
  function HeadEnd(lineEnd, lineWidth, scale, minEndStrokeWidth) {
    _classCallCheck(this, HeadEnd);
    return _callSuper$j(this, HeadEnd, [lineEnd, lineWidth, scale, minEndStrokeWidth]);
  }
  _inherits(HeadEnd, _BaseLineEnd);
  return _createClass(HeadEnd, [{
    key: "getEndDirection",
    value: function getEndDirection(svgPath) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var _SvgGraphics = new SvgGraphics(svgPath),
        segments = _SvgGraphics.segments;
      return {
        x: segments[0].x - (segments[1].x1 || segments[1].x),
        y: segments[0].y - (segments[1].y1 || segments[1].y)
      };
    }
  }]);
}(BaseLineEnd);

function _callSuper$i(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$i() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct() { return !!t; })(); }
var TailEnd = /*#__PURE__*/function (_BaseLineEnd) {
  function TailEnd(lineEnd, lineWidth, scale, minEndStrokeWidth) {
    _classCallCheck(this, TailEnd);
    return _callSuper$i(this, TailEnd, [lineEnd, lineWidth, scale, minEndStrokeWidth]);
  }
  _inherits(TailEnd, _BaseLineEnd);
  return _createClass(TailEnd, [{
    key: "getEndDirection",
    value: function getEndDirection(svgPath) {
      var _SvgGraphics = new SvgGraphics(svgPath),
        segments = _SvgGraphics.segments;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var lastSegment = segments[segments.length - 1];
      var lastSecondPointX = lastSegment.x2 || lastSegment.x1 || lastSegment.startX;
      var lastSecondPointY = lastSegment.y2 || lastSegment.y1 || lastSegment.startY;
      return {
        x: lastSegment.x - lastSecondPointX,
        y: lastSegment.y - lastSecondPointY
      };
    }
  }]);
}(BaseLineEnd);

var ShapeLineEnd = /*#__PURE__*/function () {
  function ShapeLineEnd(model, path, subPath) {
    var _this = this;
    _classCallCheck(this, ShapeLineEnd);
    this.getPathAfterCut = function () {
      return _this.pathAfterCut;
    };
    this.model = model;
    this.path = path;
    this.subPath = "M".concat(subPath);
    this.headEnd = new HeadEnd(this.model.headEnd, this.model.lineWidth || 0, this.path.scaleX, this.model.minEndStrokeWidth);
    this.tailEnd = new TailEnd(this.model.tailEnd, this.model.lineWidth || 0, this.path.scaleX, this.model.minEndStrokeWidth);
    this.updateSegmentsAfterCut();
    this.updateDirection();
  }
  return _createClass(ShapeLineEnd, [{
    key: "updateSegmentsAfterCut",
    value: function updateSegmentsAfterCut() {
      this.pathSegments = new SvgGraphics(this.subPath).segments;
      var scale = this.path.scaleX || 1;
      this.endSite = {
        head: this.headEnd.getEndStrokeWidth() * scale,
        tail: this.tailEnd.getEndStrokeWidth() * scale
      };
      this.pathAfterCut = new PathHandler({
        segments: this.pathSegments,
        endSite: this.endSite,
        scale: scale
      }).getNewPathAfterCut();
      this.segmentsAfterCut = new SvgGraphics(this.pathAfterCut).segments;
    }
  }, {
    key: "updateDirection",
    value: function updateDirection() {
      var headPos = {
        x: this.segmentsAfterCut[0].x,
        y: this.segmentsAfterCut[0].y
      };
      var headPosBeforeCut = {
        x: this.pathSegments[0].x,
        y: this.pathSegments[0].y
      };
      // 若新path与原path端点不同，说明在该端进行截断了处理，则以新旧端点的连线向量作为方向
      if (headPosBeforeCut.x !== headPos.x || headPosBeforeCut.y !== headPos.y) {
        this.headEnd.updateEndDirection({
          x: headPosBeforeCut.x - headPos.x,
          y: headPosBeforeCut.y - headPos.y
        });
      } else if (this.endSite.head !== 0) {
        this.headEnd.updateEndDirection({
          x: this.pathSegments[0].x - this.segmentsAfterCut[0].x,
          y: this.pathSegments[0].y - this.segmentsAfterCut[0].y
        });
      }
      var lastSegment = this.pathSegments[this.pathSegments.length - 1];
      var lastSegmentAfterCut = this.segmentsAfterCut[this.segmentsAfterCut.length - 1];
      var tailPos = {
        x: lastSegmentAfterCut.x,
        y: lastSegmentAfterCut.y
      };
      var tailPosBeforeCut = {
        x: lastSegment.x,
        y: lastSegment.y
      };
      if (tailPosBeforeCut.x !== tailPos.x || tailPosBeforeCut.y !== tailPos.y) {
        this.tailEnd.updateEndDirection({
          x: tailPosBeforeCut.x - tailPos.x,
          y: tailPosBeforeCut.y - tailPos.y
        });
      } else if (this.endSite.tail !== 0) {
        this.tailEnd.updateEndDirection({
          x: lastSegment.x - lastSegmentAfterCut.x,
          y: lastSegment.y - lastSegmentAfterCut.y
        });
      }
      this.headEnd.updateEndPoint(headPos.x, headPos.y);
      this.tailEnd.updateEndPoint(tailPos.x, tailPos.y);
    }
  }]);
}();

function _callSuper$h(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$h() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct() { return !!t; })(); }
var BaseShape = /*#__PURE__*/function (_BaseGraphics) {
  function BaseShape(model) {
    _classCallCheck(this, BaseShape);
    return _callSuper$h(this, BaseShape, [model]);
  }
  /**
   * 获取形状文字区域信息
   */
  _inherits(BaseShape, _BaseGraphics);
  return _createClass(BaseShape, [{
    key: "getTextRect",
    value: function getTextRect(renderWidth, renderHeight) {
      var width = renderWidth !== null && renderWidth !== void 0 ? renderWidth : this.model.width;
      var height = renderHeight !== null && renderHeight !== void 0 ? renderHeight : this.model.height;
      return {
        left: 0,
        top: 0,
        width: width,
        height: height
      };
    }
  }, {
    key: "getPathWithEnd",
    value: function getPathWithEnd(path) {
      var _this = this;
      var _a, _b;
      var pathArray = [];
      var svgPath = path.svgPath;
      // 自由曲线或形状中也可能存在端点的箭头,在path中寻找非闭合的路径认为应该是要被添加箭头的那一段
      var head = (_a = this.model.headEnd) === null || _a === void 0 ? void 0 : _a.lineEndType;
      var tail = (_b = this.model.tailEnd) === null || _b === void 0 ? void 0 : _b.lineEndType;
      var hasEnd = head && head !== LineEndType.NONE || tail && tail !== LineEndType.NONE;
      if (hasEnd && svgPath.toLowerCase().indexOf('z') === -1) {
        path.segments = undefined;
        /**
         * 某些形状画法比较特殊，可能存在用一条path画两段视觉上线段的情况，如双括号，这种path是在path中添加moveto的方式实现的
         * 针对这种情况，对一条path中所有的moveto进行分割，对分割后的每一条子路径单独添加箭头
         */
        var subPathArray = svgPath.trim().split('M');
        subPathArray.forEach(function (subPath) {
          if (!subPath.length) {
            return;
          }
          var shapeLineEnd = new ShapeLineEnd(_this.model, path, subPath);
          var headPath = shapeLineEnd.headEnd.getEndPath(svgPath);
          if (headPath) {
            headPath.scaleX = path.scaleX;
            headPath.scaleY = path.scaleY;
            pathArray.push(headPath);
          }
          var newPath = Object.assign(Object.assign({}, path), {
            svgPath: shapeLineEnd.getPathAfterCut()
          });
          pathArray.push(newPath);
          var tailPath = shapeLineEnd.tailEnd.getEndPath(svgPath);
          if (tailPath) {
            tailPath.scaleX = path.scaleX;
            tailPath.scaleY = path.scaleY;
            pathArray.push(tailPath);
          }
        });
      } else {
        pathArray.push(path);
      }
      return pathArray;
    }
  }]);
}(BaseGraphics);

// eslint-disable-next-line complexity
function spreadJSPathItemToSVGForE(variables, shapeType) {
  // eslint-disable-next-line id-length
  var x = variables[1];
  // eslint-disable-next-line id-length
  var y = variables[2];
  var radiusX = variables[3];
  var radiusY = variables[4];
  var rotation = variables[5];
  var startAngle = variables[6];
  var endAngle = variables[7];
  var antiClockwise = variables[8];
  var endX = x + radiusX * Math.cos(endAngle);
  var endY = y + radiusY * Math.sin(endAngle);
  // 左右中括号radiusY为0时 手动画直线 不然会在原地画一个点
  if (radiusY === 0 && (shapeType === 'leftBracket' || shapeType === 'rightBracket')) {
    if (shapeType === 'leftBracket') {
      endX = x + radiusX * Math.cos(2 * endAngle);
    } else if (shapeType === 'rightBracket') {
      endX = x + radiusX * Math.cos(endAngle - startAngle);
    }
    return "L ".concat(Math.abs(endX), " ").concat(endY);
  }
  // A标签画不出完整圆 如果是完整圆时 处理成两个首尾相接的半圆
  return Math.abs(endAngle - startAngle - Math.PI * 2) < 0.0000001 ? "A ".concat(radiusX, " ").concat(radiusY, " ").concat(rotation, "\n            ").concat(((antiClockwise ? -1 : 1) * (endAngle - startAngle) + Math.PI * 4) % (Math.PI * 2) > Math.PI ? 1 : 0, "\n            ").concat(antiClockwise ? 0 : 1, "\n            ").concat(endX + 2 * (x - endX), "\n            ").concat(endY + 2 * (y - endY), "\n\n            A ").concat(radiusX, " ").concat(radiusY, " ").concat(rotation, "\n                ").concat(((antiClockwise ? -1 : 1) * (endAngle - startAngle) + Math.PI * 4) % (Math.PI * 2) > Math.PI ? 1 : 0, "\n                ").concat(antiClockwise ? 0 : 1, "\n                ").concat(endX, "\n                ").concat(endY) // 画完整圆
  : "A ".concat(radiusX, " ").concat(radiusY, " ").concat(rotation, "\n                ").concat(((antiClockwise ? -1 : 1) * (endAngle - startAngle) + Math.PI * 4) % (Math.PI * 2) > Math.PI ? 1 : 0, "\n                ").concat(antiClockwise ? 0 : 1, "\n                ").concat(endX, "\n                ").concat(endY); // 画不完整圆弧
}
function spreadJSPathItemToSVG(variables, shapeType) {
  if (variables.length < 1) return null;
  var eArray = ['E', 'e'];
  var zArray = ['Z', 'z'];
  var qsArray = ['Q', 'q', 'S', 's'];
  var bcArray = ['B', 'C', 'c'];
  var mArray = ['M', 'm'];
  var lArray = ['L', 'l'];
  if (eArray.includes(variables[0])) {
    return spreadJSPathItemToSVGForE(variables, shapeType);
  }
  if (zArray.includes(variables[0])) {
    return 'Z';
  }
  if (qsArray.includes(variables[0])) {
    return "Q ".concat(variables[1], " ").concat(variables[2], " ").concat(variables[3], " ").concat(variables[4]);
  }
  if (bcArray.includes(variables[0])) {
    return "C ".concat(variables[1], " ").concat(variables[2], " ").concat(variables[3], " ").concat(variables[4], " ").concat(variables[5], " ").concat(variables[6]);
  }
  if (mArray.includes(variables[0])) {
    return "M ".concat(variables[1], " ").concat(variables[2]);
  }
  if (lArray.includes(variables[0])) {
    return "L ".concat(variables[1], " ").concat(variables[2]);
  }
  return null;
}
function pathPointsFromPathItemForE(variables, shapeType, points) {
  var currentPoints = points;
  // eslint-disable-next-line id-length
  var x = variables[1];
  // eslint-disable-next-line id-length
  var y = variables[2];
  var radiusX = variables[3];
  var radiusY = variables[4];
  var startAngle = variables[6];
  var endAngle = variables[7];
  var endX = x + radiusX * Math.cos(endAngle);
  var endY = y + radiusY * Math.sin(endAngle);
  // 左右中括号radiusY为0时 手动画直线 不然会在原地画一个点
  if (radiusY === 0 && (shapeType === 'leftBracket' || shapeType === 'rightBracket')) {
    currentPoints.push({
      x: Math.abs(endX),
      y: endY
    });
  }
  // A标签画不出完整圆 如果是完整圆时 处理成两个首尾相接的半圆
  if (Math.abs(endAngle - startAngle - Math.PI * 2) < 0.0000001) {
    currentPoints.push({
      x: endX,
      y: endY
    }, {
      x: endX + 2 * (x - endX),
      y: endY + 2 * (y - endY)
    }); // 画完整圆
  } else {
    currentPoints.push({
      x: endX,
      y: endY
    }); // 这个地方不太对，但是对于当前4个形状应该不涉及到
  }
  return currentPoints;
}
// eslint-disable-next-line
function pathPointsFromPathItem(variables, shapeType) {
  var points = [];
  if (variables.length < 1) return points;
  var eArray = ['E', 'e'];
  var qsArray = ['Q', 'q', 'S', 's'];
  var bcArray = ['B', 'C', 'c'];
  var mlArray = ['M', 'm', 'L', 'l'];
  if (eArray.includes(variables[0])) {
    points = pathPointsFromPathItemForE(variables, shapeType, points);
  } else if (qsArray.includes(variables[0])) {
    points.push({
      x: variables[3],
      y: variables[4]
    });
  } else if (bcArray.includes(variables[0])) {
    points.push({
      x: variables[5],
      y: variables[6]
    });
  } else if (mlArray.includes(variables[0])) {
    points.push({
      x: variables[1],
      y: variables[2]
    });
  }
  return points;
}

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper$g(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$g() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$g() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$g = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet$1(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var SpreadJSShape = /*#__PURE__*/function (_BaseShape) {
  function SpreadJSShape(model) {
    var _this;
    _classCallCheck(this, SpreadJSShape);
    _this = _callSuper$g(this, SpreadJSShape, [model]);
    _this.update = function (model) {
      _superPropGet$1((SpreadJSShape), "update", _this, 3)([model]);
      _this.updateControlValues();
    };
    _this.getDefaultControlValues = function () {
      return _this.spreadJS.getDefaultcontrolInfos(_this.spreadJS.getAutoShapeType(_this.model.type));
    };
    _this.svgPathInRect = function () {
      var _this$model = _this.model,
        type = _this$model.type,
        width = _this$model.width,
        height = _this$model.height;
      var path = _this.spreadJS.getPath(type, width, height, _this.controlValues);
      return _this.convertPathInfo(path.path);
    };
    _this.getControlPoints = function () {
      var _this$model2 = _this.model,
        type = _this$model2.type,
        width = _this$model2.width,
        height = _this$model2.height;
      var ci = _this.spreadJS.getControlinfos(type, _this.controlValues, width, height);
      if (!ci.controlsInfo) {
        return [];
      }
      return ci.controlsInfo.map(function (point) {
        return {
          x: point.point[0],
          y: point.point[1]
        };
      });
    };
    _this.getControlInfo = function () {
      var _this$model3 = _this.model,
        type = _this$model3.type,
        width = _this$model3.width,
        height = _this$model3.height;
      var ci = _this.spreadJS.getControlinfos(type, _this.controlValues, width, height);
      return ci.controlsInfo || [];
    };
    /**
     * 获取形状文字区域信息，支持以传入宽高为准计算文字区域
     */
    _this.getTextRect = function (renderWidth, renderHeight) {
      var type = _this.model.type;
      var width = renderWidth !== null && renderWidth !== void 0 ? renderWidth : _this.model.width;
      var height = renderHeight !== null && renderHeight !== void 0 ? renderHeight : _this.model.height;
      var _this$spreadJS$getTex = _this.spreadJS.getTextRect(type, _this.controlValues, width, height),
        textRect = _this$spreadJS$getTex.textRect;
      if (textRect === undefined) {
        return {
          left: 0,
          top: 0,
          width: width,
          height: height
        };
      }
      var retObj = _this.textRectWithControlValuesForError(textRect);
      if (retObj) {
        return retObj;
      }
      return {
        left: textRect.left,
        top: textRect.top,
        width: textRect.right - textRect.left,
        height: textRect.bottom - textRect.top
      };
    };
    _this.getConnectionPoints = function (renderWidth, renderHeight, controlValues) {
      var type = _this.model.type;
      var width = renderWidth !== null && renderWidth !== void 0 ? renderWidth : _this.model.width;
      var height = renderHeight !== null && renderHeight !== void 0 ? renderHeight : _this.model.height;
      return _this.spreadJS.getConnectionPoints(type, width, height, controlValues !== null && controlValues !== void 0 ? controlValues : _this.controlValues);
    };
    _this.getControlValuesWhenControlPointChange = function (controlPointIndex, newPointPosition) {
      if (!(newPointPosition === null || newPointPosition === void 0 ? void 0 : newPointPosition.x) && (newPointPosition === null || newPointPosition === void 0 ? void 0 : newPointPosition.y)) {
        return _this.controlValues;
      }
      var _this$model4 = _this.model,
        type = _this$model4.type,
        width = _this$model4.width,
        height = _this$model4.height;
      return _this.spreadJS.changeVariable(type, controlPointIndex, newPointPosition, width, height, _this.controlValues);
    };
    _this.getShapeWrapRect = function () {
      var _this$model5 = _this.model,
        type = _this$model5.type,
        width = _this$model5.width,
        height = _this$model5.height;
      if (!(type === GraphicsType.CLOUD_CALLOUT || type === GraphicsType.WEDGE_RECT_CALLOUT || type === GraphicsType.WEDGE_ROUND_RECT_CALLOUT || type === GraphicsType.WEDGE_ELLIPSE_CALLOUT)) {
        // 先支持这几种图形的，其余的都返回矩形
        return _superPropGet$1((SpreadJSShape), "getShapeWrapRect", _this, 3)([]);
      }
      var path = _this.spreadJS.getPath(type, width, height, _this.controlValues);
      return _this.getWrapRectFromSpreadPathInfo(path.path);
    };
    _this.getWrapRectFromSpreadPathInfo = function (originPathInfo) {
      var _this$model6 = _this.model,
        type = _this$model6.type,
        width = _this$model6.width,
        height = _this$model6.height;
      var rect = {
        left: 0,
        top: 0,
        width: width,
        height: height
      };
      if (!originPathInfo) {
        return rect;
      }
      var _iterator = _createForOfIteratorHelper(originPathInfo),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var path = _step.value;
          var _iterator2 = _createForOfIteratorHelper(path),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var pathSegment = _step2.value;
              if (!Array.isArray(pathSegment)) {
                return rect;
              }
              if (!isCalcError(pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment[1])) {
                var points = pathPointsFromPathItem(pathSegment, type);
                _this.expandRectByPoint(rect, points);
              } else {
                console.error("[alloy-graphics] [path-error], shape:".concat(type, ", controlValues:").concat(_this.model.controlValues, ", width:").concat(width, ", height:").concat(height, ", path => ").concat(pathSegment));
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return rect;
    };
    _this.expandRectByPoint = function (rect, points) {
      points.forEach(function (point) {
        if (point.x < rect.left) {
          rect.width += rect.left - point.x;
          rect.left = point.x;
        }
        if (point.y < rect.top) {
          rect.height += rect.top - point.y;
          rect.top = point.y;
        }
        if (point.x > rect.width) {
          rect.width = point.x;
        }
        if (point.y > rect.height) {
          rect.height = point.y;
        }
      });
    };
    _this.initSpreadJS = function () {
      _this.spreadJS = new SpreadJS();
      var _this$model7 = _this.model,
        type = _this$model7.type,
        width = _this$model7.width,
        height = _this$model7.height;
      _this.spreadJS.getPropertySource(_this.spreadJS.getBaseShape(type), width, height);
    };
    _this.textRectWithControlValuesForError = function (textRect) {
      var hasError = Object.values(textRect).filter(function (value) {
        return isCalcError(value) || isNaN(value);
      }).length > 0;
      if (hasError) {
        var _this$model8 = _this.model,
          width = _this$model8.width,
          height = _this$model8.height;
        return {
          left: 0,
          top: height / 2,
          width: width,
          height: 0
        };
      }
      return null;
    };
    _this.convertPathInfo = function (originPathInfo) {
      if (!originPathInfo) {
        return [];
      }
      var _this$model9 = _this.model,
        type = _this$model9.type,
        width = _this$model9.width,
        height = _this$model9.height,
        controlValues = _this$model9.controlValues;
      var pathArray = [];
      var _iterator3 = _createForOfIteratorHelper(originPathInfo),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var path = _step3.value;
          var svgPath = '';
          var fillMode = void 0;
          var notStroke = void 0;
          var _iterator4 = _createForOfIteratorHelper(path),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var pathSegment = _step4.value;
              if (Array.isArray(pathSegment)) {
                if (!isCalcError(pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment[1])) {
                  svgPath += "".concat(spreadJSPathItemToSVG(pathSegment, type), " ");
                } else {
                  console.error("[alloy-graphics] [path-error], shape:".concat(type, ", controlValues:").concat(controlValues, ", width:").concat(width, ", height:").concat(height, ", path => ").concat(pathSegment));
                }
              } else {
                fillMode = pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.fillMode;
                notStroke = (pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.strokeMode) === 'false';
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          var pathObj = {
            svgPath: svgPath,
            fillMode: fillMode,
            notStroke: notStroke
          };
          pathArray.push.apply(pathArray, _toConsumableArray(_this.getPathWithEnd(pathObj)));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return pathArray;
    };
    _this.initSpreadJS();
    _this.updateControlValues();
    return _this;
  }
  _inherits(SpreadJSShape, _BaseShape);
  return _createClass(SpreadJSShape);
}(BaseShape);

function _callSuper$f(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$f() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct() { return !!t; })(); }
var Rect = /*#__PURE__*/function (_BaseShape) {
  function Rect(model) {
    _classCallCheck(this, Rect);
    return _callSuper$f(this, Rect, [model]);
  }
  _inherits(Rect, _BaseShape);
  return _createClass(Rect, [{
    key: "svgPathInRect",
    value: function svgPathInRect() {
      var _this$model = this.model,
        width = _this$model.width,
        height = _this$model.height;
      return [{
        svgPath: "M 0 0 L ".concat(width, " 0 L ").concat(width, " ").concat(height, " L 0 ").concat(height, " Z")
      }];
    }
  }, {
    key: "getControlValuesWhenControlPointChange",
    value: function getControlValuesWhenControlPointChange() {
      return [];
    }
  }]);
}(BaseShape);

function _callSuper$e(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$e() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct() { return !!t; })(); }
var Custom = /*#__PURE__*/function (_BaseShape) {
  function Custom(model) {
    _classCallCheck(this, Custom);
    return _callSuper$e(this, Custom, [model]);
  }
  _inherits(Custom, _BaseShape);
  return _createClass(Custom, [{
    key: "svgPathInRect",
    value: function svgPathInRect() {
      var _this = this;
      if (!this.model.pathList) {
        return [];
      }
      var _this$model = this.model,
        width = _this$model.width,
        height = _this$model.height;
      var pathArray = [];
      // 先得到fill不为空的，即优先画填充（从 OOXML 本地测试验证的规则）
      this.model.pathList.forEach(function (path) {
        if (!path || path.fill === FillMode.NONE) return;
        var pathObj = _this.getPathObjFromPathList(path, width, height);
        pathArray.push.apply(pathArray, _toConsumableArray(_this.getPathWithEnd(pathObj)));
      });
      // 再画fill为空的，即边框相关的内容
      this.model.pathList.forEach(function (path) {
        if (!path || path.fill !== FillMode.NONE) return;
        var pathObj = _this.getPathObjFromPathList(path, width, height);
        pathArray.push.apply(pathArray, _toConsumableArray(_this.getPathWithEnd(pathObj)));
      });
      return pathArray;
    }
  }, {
    key: "getControlValuesWhenControlPointChange",
    value: function getControlValuesWhenControlPointChange() {
      return [];
    }
  }, {
    key: "getScaledSegments",
    value: function getScaledSegments(path) {
      var _this$getScaleInfo = this.getScaleInfo(path),
        scaleX = _this$getScaleInfo.scaleX,
        scaleY = _this$getScaleInfo.scaleY;
      var segments = PathParser.parse(path.pathString);
      segments.forEach(function (segment) {
        segment.x = Math.round(segment.x * scaleX);
        segment.y = Math.round(segment.y * scaleY);
        if (segment.cmd === Command.LineTo) {
          segment.startX = Math.round(segment.startX * scaleX);
          segment.startY = Math.round(segment.startY * scaleY);
        } else if (segment.cmd === Command.CurveTo) {
          segment.x1 = Math.round(segment.x1 * scaleX);
          segment.y1 = Math.round(segment.y1 * scaleY);
          segment.x2 = Math.round(segment.x2 * scaleX);
          segment.y2 = Math.round(segment.y2 * scaleY);
          segment.startX = Math.round(segment.startX * scaleX);
          segment.startY = Math.round(segment.startY * scaleY);
        } else if (segment.cmd === Command.QuadraticCurveTo) {
          segment.x1 = Math.round(segment.x1 * scaleX);
          segment.y1 = Math.round(segment.y1 * scaleY);
          segment.startX = Math.round(segment.startX * scaleX);
          segment.startY = Math.round(segment.startY * scaleY);
        } else if (segment.cmd === Command.ClosePath) {
          segment.startX = Math.round(segment.startX * scaleX);
          segment.startY = Math.round(segment.startY * scaleY);
        }
      });
      return segments;
    }
    /**
     * 根据 segments 重新计算自定义图形的 path
     * @private
     * @param segments
     */
  }, {
    key: "getScaledPath",
    value: function getScaledPath(segments) {
      var scaledPath = '';
      segments.forEach(function (segment) {
        if (segment.cmd === Command.MoveTo || segment.cmd === Command.LineTo) {
          scaledPath += "".concat(segment.cmd, " ").concat(segment.x, " ").concat(segment.y, " ");
        } else if (segment.cmd === Command.CurveTo) {
          scaledPath += "".concat(segment.cmd, " ").concat(segment.x1, " ").concat(segment.y1, ", ").concat(segment.x2, " ").concat(segment.y2, ", ").concat(segment.x, " ").concat(segment.y, " ");
        } else if (segment.cmd === Command.QuadraticCurveTo) {
          scaledPath += "".concat(segment.cmd, " ").concat(segment.x1, " ").concat(segment.y1, ", ").concat(segment.x, " ").concat(segment.y, " ");
        } else if (segment.cmd === Command.ClosePath) {
          scaledPath += segment.cmd;
        }
      });
      return scaledPath;
    }
  }, {
    key: "getScaleInfo",
    value: function getScaleInfo(path) {
      var _a, _b;
      // 自定义图形在没有w和h的时候给的默认缩小比例改为6350
      var pathWidth = (_a = path === null || path === void 0 ? void 0 : path.width) !== null && _a !== void 0 ? _a : this.model.width * 6350;
      var pathHeight = (_b = path === null || path === void 0 ? void 0 : path.height) !== null && _b !== void 0 ? _b : this.model.height * 6350;
      var scaleX = pathWidth === 0 ? 1 : this.model.width / pathWidth;
      var scaleY = pathHeight === 0 ? scaleX : this.model.height / pathHeight;
      if (scaleX === 0) scaleX = 1 / pathWidth;
      if (scaleY === 0) scaleY = 1 / pathHeight;
      return {
        scaleX: scaleX,
        scaleY: scaleY
      };
    }
  }, {
    key: "getPathObjFromPathList",
    value: function getPathObjFromPathList(path, width, height) {
      var _a;
      var notStroke = path.stroke === 0;
      var fillMode = (_a = path.fill) !== null && _a !== void 0 ? _a : FillMode.NORMAL;
      var needPath = !(width === 0 && height === 0);
      var segments = needPath ? this.getScaledSegments(path) : undefined;
      var scaledPath = needPath ? this.getScaledPath(segments) : '';
      // 元素宽高都为 0 时，返回空 path，避免应用 scale 后显示错误
      return {
        svgPath: scaledPath,
        segments: segments,
        scaleX: 1,
        scaleY: 1,
        notStroke: notStroke,
        fillMode: fillMode
      };
    }
  }]);
}(BaseShape);

function _callSuper$d(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$d() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var BaseLine = /*#__PURE__*/function (_BaseGraphics) {
  function BaseLine(model) {
    var _this;
    _classCallCheck(this, BaseLine);
    _this = _callSuper$d(this, BaseLine, [model]);
    _this.getControlValuesWhenControlPointChange = function (controlPointIndex, newPointPosition) {
      var _this$model = _this.model,
        width = _this$model.width,
        height = _this$model.height;
      var value = newPointPosition.y / height;
      if (controlPointIndex % 2 === 0) {
        value = newPointPosition.x / width;
      }
      var tempArray = _toConsumableArray(_this.controlValues);
      tempArray.splice(controlPointIndex, 1, value);
      return tempArray;
    };
    _this.headEnd = new HeadEnd(_this.model.headEnd, _this.model.lineWidth || 0, 1, model.minEndStrokeWidth);
    _this.tailEnd = new TailEnd(_this.model.tailEnd, _this.model.lineWidth || 0, 1, model.minEndStrokeWidth);
    _this.updateControlValues();
    _this.updateEndPoints();
    return _this;
  }
  _inherits(BaseLine, _BaseGraphics);
  return _createClass(BaseLine, [{
    key: "update",
    value: function update(model) {
      _superPropGet(BaseLine, "update", this, 3)([model]);
      this.updateControlValues();
      this.headEnd.update(this.model.headEnd, this.model.lineWidth || 0, 1, model.minEndStrokeWidth);
      this.tailEnd.update(this.model.tailEnd, this.model.lineWidth || 0, 1, model.minEndStrokeWidth);
      this.updateEndPoints();
    }
  }, {
    key: "svgPathInRect",
    value: function svgPathInRect() {
      var linePath = this.getLinePath();
      var headPath = this.headEnd.getEndPath(linePath.svgPath);
      var tailPath = this.tailEnd.getEndPath(linePath.svgPath);
      var pathArray = [];
      if (headPath) {
        pathArray.push(headPath);
      }
      pathArray.push(linePath);
      if (tailPath) {
        pathArray.push(tailPath);
      }
      return pathArray;
    }
  }]);
}(BaseGraphics);

/**
 * 两点之间的距离
 */
function distanceBetweenTwoPoints(p1, p2) {
  return Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
}
/**
 * 极坐标 (r, θ)转笛卡尔坐标 (x, y)
 * @param centerX
 * @param centerY
 * @param rX
 * @param rY
 * @param angleInDegrees
 */
function polarToCartesian(centerX, centerY, rX, rY, angleInDegrees) {
  var angleInRadians = angleToRadian(angleInDegrees - 90);
  // Todo 两个坐标相加的逻辑应该抽到另一个方法里
  return {
    x: centerX + rX * Math.cos(angleInRadians),
    y: centerY + rY * Math.sin(angleInRadians)
  };
}
/**
 * 角度转弧度
 * @param angle
 */
function angleToRadian(angle) {
  return Math.PI / 180.0 * angle;
}
/**
 * 点相对与向量的方向：1表示右手方向，-1表示左手方向，0表示在直线上
 */
function pointToSegment(point, segment) {
  var v1 = {
    x: segment.p1.x - point.x,
    y: segment.p1.y - point.y
  };
  var v2 = {
    x: segment.p2.x - point.x,
    y: segment.p2.y - point.y
  };
  return crossMultiply(v1, v2);
}
/**
 * 向量叉乘
 * @param v1
 * @param v2
 */
function crossMultiply(v1, v2) {
  return v1.x * v2.y - v2.x * v1.y;
}

function _callSuper$c(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$c() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct() { return !!t; })(); }
var StraightLine = /*#__PURE__*/function (_BaseLine) {
  function StraightLine(model) {
    _classCallCheck(this, StraightLine);
    return _callSuper$c(this, StraightLine, [model]);
  }
  _inherits(StraightLine, _BaseLine);
  return _createClass(StraightLine, [{
    key: "getLinePath",
    value: function getLinePath() {
      var svgPath = "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " L").concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y);
      return {
        svgPath: svgPath,
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model = this.model,
        width = _this$model.width,
        height = _this$model.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var headPoint;
      var tailPoint;
      if (width < 1e-4) {
        headPoint = {
          x: 0,
          y: headWidth
        };
        tailPoint = {
          x: width,
          y: height - tailWidth
        };
      } else if (height < 1e-4) {
        headPoint = {
          x: headWidth,
          y: 0
        };
        tailPoint = {
          x: width - tailWidth,
          y: height
        };
      } else {
        var p1 = {
          x: 0,
          y: 0
        };
        var p2 = {
          x: width,
          y: height
        };
        var l = distanceBetweenTwoPoints(p1, p2);
        headPoint = {
          x: headWidth * width / l,
          y: headWidth * height / l
        };
        tailPoint = {
          x: width - tailWidth * width / l,
          y: height - tailWidth * height / l
        };
      }
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseLine);

function _callSuper$b(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$b() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 无控制点折线
 */
var NoneControlPointBentLine = /*#__PURE__*/function (_BaseLine) {
  function NoneControlPointBentLine(model) {
    _classCallCheck(this, NoneControlPointBentLine);
    return _callSuper$b(this, NoneControlPointBentLine, [model]);
  }
  _inherits(NoneControlPointBentLine, _BaseLine);
  return _createClass(NoneControlPointBentLine, [{
    key: "getLinePath",
    value: function getLinePath() {
      var svgPath = "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " L").concat(this.tailEnd.point.x, " ").concat(this.headEnd.point.y, " L").concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y);
      return {
        svgPath: svgPath,
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model = this.model,
        width = _this$model.width,
        height = _this$model.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var headPoint = {
        x: headWidth,
        y: 0
      };
      var tailPoint = {
        x: width,
        y: height - tailWidth
      };
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseLine);

function _callSuper$a(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$a() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 单控制点折线
 */
var SingleControlPointBentLine = /*#__PURE__*/function (_BaseLine) {
  function SingleControlPointBentLine(model) {
    var _this;
    _classCallCheck(this, SingleControlPointBentLine);
    _this = _callSuper$a(this, SingleControlPointBentLine, [model]);
    _this.getControlPoints = function () {
      var _this$model = _this.model,
        width = _this$model.width,
        height = _this$model.height;
      return [{
        x: width * _this.controlValues[0],
        y: height / 2
      }];
    };
    return _this;
  }
  _inherits(SingleControlPointBentLine, _BaseLine);
  return _createClass(SingleControlPointBentLine, [{
    key: "getDefaultControlValues",
    value: function getDefaultControlValues() {
      return [0.5];
    }
  }, {
    key: "getLinePath",
    value: function getLinePath() {
      var _this$getControlPoint = this.getControlPoints(),
        _this$getControlPoint2 = _slicedToArray(_this$getControlPoint, 1),
        point = _this$getControlPoint2[0];
      return {
        svgPath: "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " ") + "L".concat(point.x, " ").concat(this.headEnd.point.y, " ") + "L".concat(point.x, " ").concat(this.tailEnd.point.y, " ") + "L".concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y),
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model2 = this.model,
        width = _this$model2.width,
        height = _this$model2.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var headPoint = {
        x: (this.controlValues[0] < 0 ? -1 : 1) * headWidth,
        y: 0
      };
      var tailPoint = {
        x: width - (this.controlValues[0] > 1 ? -1 : 1) * tailWidth,
        y: height
      };
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseLine);

function _callSuper$9(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$9() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 双控制点折线
 */
var TwoControlPointsBentLine = /*#__PURE__*/function (_BaseLine) {
  function TwoControlPointsBentLine(model) {
    var _this;
    _classCallCheck(this, TwoControlPointsBentLine);
    _this = _callSuper$9(this, TwoControlPointsBentLine, [model]);
    _this.getControlPoints = function () {
      var _this$model = _this.model,
        width = _this$model.width,
        height = _this$model.height;
      return [{
        x: width * _this.controlValues[0],
        y: height * _this.controlValues[1] / 2
      }, {
        x: width * (1 + _this.controlValues[0]) / 2,
        y: height * _this.controlValues[1]
      }];
    };
    return _this;
  }
  _inherits(TwoControlPointsBentLine, _BaseLine);
  return _createClass(TwoControlPointsBentLine, [{
    key: "getDefaultControlValues",
    value: function getDefaultControlValues() {
      return [0.5, 0.5];
    }
  }, {
    key: "getLinePath",
    value: function getLinePath() {
      var _this$getControlPoint = this.getControlPoints(),
        _this$getControlPoint2 = _slicedToArray(_this$getControlPoint, 2),
        point1 = _this$getControlPoint2[0],
        point2 = _this$getControlPoint2[1];
      return {
        svgPath: "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " ") + "L".concat(point1.x, " ").concat(this.headEnd.point.y, " ") + "L".concat(point1.x, " ").concat(point2.y, " ") + "L".concat(this.tailEnd.point.x, " ").concat(point2.y, " ") + "L".concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y),
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model2 = this.model,
        width = _this$model2.width,
        height = _this$model2.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var headPoint = {
        x: (this.controlValues[0] < 0 ? -1 : 1) * headWidth,
        y: 0
      };
      var tailPoint = {
        x: width,
        y: height - (this.controlValues[1] > 1 ? -1 : 1) * tailWidth
      };
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseLine);

function _callSuper$8(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$8() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 三个控制点折线
 */
var ThreeControlPointsBentLine = /*#__PURE__*/function (_BaseLine) {
  function ThreeControlPointsBentLine(model) {
    var _this;
    _classCallCheck(this, ThreeControlPointsBentLine);
    _this = _callSuper$8(this, ThreeControlPointsBentLine, [model]);
    _this.getControlPoints = function () {
      var _this$model = _this.model,
        width = _this$model.width,
        height = _this$model.height;
      return [{
        x: width * _this.controlValues[0],
        y: height * _this.controlValues[1] / 2
      }, {
        x: width * (_this.controlValues[2] + _this.controlValues[0]) / 2,
        y: height * _this.controlValues[1]
      }, {
        x: width * _this.controlValues[2],
        y: height * (1 + _this.controlValues[1]) / 2
      }];
    };
    return _this;
  }
  _inherits(ThreeControlPointsBentLine, _BaseLine);
  return _createClass(ThreeControlPointsBentLine, [{
    key: "getDefaultControlValues",
    value: function getDefaultControlValues() {
      return [0.5, 0.5, 0.5];
    }
  }, {
    key: "getLinePath",
    value: function getLinePath() {
      var _this$getControlPoint = this.getControlPoints(),
        _this$getControlPoint2 = _slicedToArray(_this$getControlPoint, 3),
        point1 = _this$getControlPoint2[0],
        point2 = _this$getControlPoint2[1],
        point3 = _this$getControlPoint2[2];
      return {
        svgPath: "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " ") + "L".concat(point1.x, " ").concat(this.headEnd.point.y, " ") + "L".concat(point1.x, " ").concat(point2.y, " ") + "L".concat(point3.x, " ").concat(point2.y, " ") + "L".concat(point3.x, " ").concat(this.tailEnd.point.y, " ") + "L".concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y),
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model2 = this.model,
        width = _this$model2.width,
        height = _this$model2.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var headPoint = {
        x: (this.controlValues[0] < 0 ? -1 : 1) * headWidth,
        y: 0
      };
      var tailPoint = {
        x: width - (this.controlValues[2] > 1 ? -1 : 1) * tailWidth,
        y: height
      };
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseLine);

function _callSuper$7(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$7() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() { return !!t; })(); }
var BaseCurvedLine = /*#__PURE__*/function (_BaseLine) {
  function BaseCurvedLine() {
    _classCallCheck(this, BaseCurvedLine);
    return _callSuper$7(this, BaseCurvedLine, arguments);
  }
  _inherits(BaseCurvedLine, _BaseLine);
  return _createClass(BaseCurvedLine, [{
    key: "getHeadPoint",
    value: function getHeadPoint(crossAngle, p1, p2, clockWise) {
      var rX = Math.abs(p2.x - p1.x);
      var rY = Math.abs(p2.y - p1.y);
      if (clockWise === 1) {
        if (p2.x >= p1.x) {
          if (p2.y >= p1.y) {
            return polarToCartesian(p1.x, p1.y + rY, rX, rY, crossAngle);
          }
          return polarToCartesian(p1.x + rX, p1.y, rX, rY, 270 + crossAngle);
        }
        if (p2.y >= p1.y) {
          return polarToCartesian(p1.x - rX, p1.y, rX, rY, 90 + crossAngle);
        }
        return polarToCartesian(p1.x, p1.y - rY, rX, rY, 180 + crossAngle);
      }
      if (p2.x >= p1.x) {
        if (p2.y >= p1.y) {
          return polarToCartesian(p1.x + rX, p1.y, rX, rY, 270 - crossAngle);
        }
        return polarToCartesian(p1.x, p1.y - rY, rX, rY, 180 - crossAngle);
      }
      if (p2.y >= p1.y) {
        return polarToCartesian(p1.x, p1.y + rY, rX, rY, 360 - crossAngle);
      }
      return polarToCartesian(p1.x - rX, p1.y, rX, rY, 90 - crossAngle);
    }
  }, {
    key: "getTailPoint",
    value: function getTailPoint(crossAngle, p1, p2, clockWise) {
      var rX = Math.abs(p2.x - p1.x);
      var rY = Math.abs(p2.y - p1.y);
      if (clockWise === 1) {
        if (p2.x >= p1.x) {
          if (p2.y >= p1.y) {
            return polarToCartesian(p1.x, p1.y + rY, rX, rY, 90 - crossAngle);
          }
          return polarToCartesian(p1.x + rX, p1.y, rX, rY, 360 - crossAngle);
        }
        if (p2.y >= p1.y) {
          return polarToCartesian(p1.x - rX, p1.y, rX, rY, 180 - crossAngle);
        }
        return polarToCartesian(p1.x, p1.y - rY, rX, rY, 270 - crossAngle);
      }
      if (p2.x >= p1.x) {
        if (p2.y >= p1.y) {
          return polarToCartesian(p1.x + rX, p1.y, rX, rY, 180 + crossAngle);
        }
        return polarToCartesian(p1.x, p1.y - rY, rX, rY, 90 + crossAngle);
      }
      if (p2.y >= p1.y) {
        return polarToCartesian(p1.x, p1.y + rY, rX, rY, 270 + crossAngle);
      }
      return polarToCartesian(p1.x - rX, p1.y, rX, rY, crossAngle);
    }
  }, {
    key: "getCrossAngle",
    value: function getCrossAngle(length, w, h) {
      var ratio = Math.max(w, h) / (Math.min(w, h) > 0 ? Math.min(w, h) : 1);
      if (ratio > 8) {
        ratio = 2;
      }
      var l = 0;
      var r = 90 * ratio;
      var topPoint = {
        x: 0,
        y: h
      };
      var mid = 0;
      while (l <= r) {
        mid = Math.floor(l + Math.floor(r - l >> 1));
        var midPos = {
          x: w * Math.cos(angleToRadian(90 - mid / ratio)),
          y: h * Math.sin(angleToRadian(90 - mid / ratio))
        };
        var distance = distanceBetweenTwoPoints(midPos, topPoint);
        if (distance > length) {
          r = mid - 1;
        } else if (distance < length) {
          l = mid + 1;
        } else {
          break;
        }
      }
      if (mid * ratio <= 1) return 0;
      return mid / ratio;
    }
  }]);
}(BaseLine);

function _callSuper$6(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$6() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 无控制点曲线
 */
var NoneControlPointCurvedLine = /*#__PURE__*/function (_BaseCurvedLine) {
  function NoneControlPointCurvedLine(model) {
    _classCallCheck(this, NoneControlPointCurvedLine);
    return _callSuper$6(this, NoneControlPointCurvedLine, [model]);
  }
  _inherits(NoneControlPointCurvedLine, _BaseCurvedLine);
  return _createClass(NoneControlPointCurvedLine, [{
    key: "getLinePath",
    value: function getLinePath() {
      var _this$model = this.model,
        width = _this$model.width,
        height = _this$model.height;
      return {
        svgPath: "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " ") + "A".concat(width, " ").concat(height, " 0 0 1 ").concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y),
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model2 = this.model,
        width = _this$model2.width,
        height = _this$model2.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var connectPoints = [{
        x: 0,
        y: 0
      }, {
        x: width,
        y: height
      }];
      var bentPoints = [{
        x: width,
        y: 0
      }];
      var clockwise = [];
      for (var i = 0; i + 1 < connectPoints.length; i++) {
        var dir = pointToSegment(bentPoints[i], {
          p1: connectPoints[i],
          p2: connectPoints[i + 1]
        });
        clockwise.push(dir >= 0 ? 0 : 1);
      }
      var startCrossAngle = this.getCrossAngle(headWidth, width, height);
      var headPoint = this.getHeadPoint(startCrossAngle, connectPoints[0], connectPoints[1], clockwise[0]);
      var endCrossAngle = this.getCrossAngle(tailWidth, height, width);
      var tailPoint = this.getTailPoint(endCrossAngle, connectPoints[0], connectPoints[1], clockwise[0]);
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseCurvedLine);

function _callSuper$5(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$5() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 单控制点曲线
 */
var SingleControlPointCurvedLine = /*#__PURE__*/function (_BaseCurvedLine) {
  function SingleControlPointCurvedLine(model) {
    var _this;
    _classCallCheck(this, SingleControlPointCurvedLine);
    _this = _callSuper$5(this, SingleControlPointCurvedLine, [model]);
    _this.getControlPoints = function () {
      var _this$model = _this.model,
        width = _this$model.width,
        height = _this$model.height;
      return [{
        x: width * _this.controlValues[0],
        y: height / 2
      }];
    };
    return _this;
  }
  _inherits(SingleControlPointCurvedLine, _BaseCurvedLine);
  return _createClass(SingleControlPointCurvedLine, [{
    key: "getDefaultControlValues",
    value: function getDefaultControlValues() {
      return [0.5];
    }
  }, {
    key: "getLinePath",
    value: function getLinePath() {
      var width = this.model.width;
      var _this$getControlPoint = this.getControlPoints(),
        _this$getControlPoint2 = _slicedToArray(_this$getControlPoint, 1),
        point = _this$getControlPoint2[0];
      return {
        svgPath: "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " ") + "A".concat(point.x, " ").concat(point.y, " 0 0 ").concat(this.clockwise[0] > 0 ? 1 : 0, " ").concat(point.x, " ").concat(point.y, " ") + "A".concat(width - point.x, " ").concat(point.y, " 0 0 ").concat(this.clockwise[1] > 0 ? 1 : 0, " ").concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y),
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model2 = this.model,
        width = _this$model2.width,
        height = _this$model2.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var _this$controlValues = _slicedToArray(this.controlValues, 1),
        controlValue = _this$controlValues[0];
      var connectPoints = [{
        x: 0,
        y: 0
      }, {
        x: width * controlValue,
        y: height / 2
      }, {
        x: width,
        y: height
      }];
      var bentPoints = [{
        x: width * controlValue,
        y: 0
      }, {
        x: width * controlValue,
        y: height
      }];
      this.clockwise = [];
      for (var i = 0; i + 1 < connectPoints.length; i++) {
        var dir = pointToSegment(bentPoints[i], {
          p1: connectPoints[i],
          p2: connectPoints[i + 1]
        });
        this.clockwise.push(dir >= 0 ? 0 : 1);
      }
      var startCrossAngle = this.getCrossAngle(headWidth, width * Math.abs(controlValue), height / 2);
      var headPoint = this.getHeadPoint(startCrossAngle, connectPoints[0], connectPoints[1], this.clockwise[0]);
      var endCrossAngle = this.getCrossAngle(tailWidth, width * Math.abs(1 - controlValue), height / 2);
      var tailPoint = this.getTailPoint(endCrossAngle, connectPoints[1], connectPoints[2], this.clockwise[1]);
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseCurvedLine);

function _callSuper$4(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$4() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 双控制点曲线
 */
var TwoControlPointsCurvedLine = /*#__PURE__*/function (_BaseCurvedLine) {
  function TwoControlPointsCurvedLine(model) {
    var _this;
    _classCallCheck(this, TwoControlPointsCurvedLine);
    _this = _callSuper$4(this, TwoControlPointsCurvedLine, [model]);
    _this.getControlPoints = function () {
      var _this$model = _this.model,
        width = _this$model.width,
        height = _this$model.height;
      return [{
        x: width * _this.controlValues[0],
        y: height * _this.controlValues[1] / 2
      }, {
        x: width * (1 + _this.controlValues[0]) / 2,
        y: height * _this.controlValues[1]
      }];
    };
    return _this;
  }
  _inherits(TwoControlPointsCurvedLine, _BaseCurvedLine);
  return _createClass(TwoControlPointsCurvedLine, [{
    key: "getDefaultControlValues",
    value: function getDefaultControlValues() {
      return [0.5, 0.5];
    }
  }, {
    key: "getLinePath",
    value: function getLinePath() {
      var _this$model2 = this.model,
        width = _this$model2.width,
        height = _this$model2.height;
      var _this$getControlPoint = this.getControlPoints(),
        _this$getControlPoint2 = _slicedToArray(_this$getControlPoint, 2),
        point1 = _this$getControlPoint2[0],
        point2 = _this$getControlPoint2[1];
      return {
        svgPath: "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " ") + "A".concat(point1.x, " ").concat(point1.y, ",0 0 ").concat(this.clockwise[0] > 0 ? 1 : 0, " ").concat(point1.x, " ").concat(point1.y, " ") + "A".concat((width - point1.x) / 2, " ").concat(point1.y, ",0 0 ").concat(this.clockwise[1] > 0 ? 1 : 0, " ").concat(point2.x, " ").concat(point2.y, " ") + "A".concat((width - point1.x) / 2, " ").concat(height - point2.y, ",0 0 ").concat(this.clockwise[2] > 0 ? 1 : 0, " ").concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y),
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model3 = this.model,
        width = _this$model3.width,
        height = _this$model3.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var _this$controlValues = _slicedToArray(this.controlValues, 2),
        controlValue1 = _this$controlValues[0],
        controlValue2 = _this$controlValues[1];
      var connectPoints = [{
        x: 0,
        y: 0
      }, {
        x: width * controlValue1,
        y: height * controlValue2 / 2
      }, {
        x: width * (controlValue1 + 1) / 2,
        y: height * controlValue2
      }, {
        x: width,
        y: height
      }];
      var bentPoints = [{
        x: width * controlValue1,
        y: 0
      }, {
        x: width * controlValue1,
        y: height * controlValue2
      }, {
        x: width,
        y: height * controlValue2
      }];
      this.clockwise = [];
      for (var i = 0; i + 1 < connectPoints.length; i++) {
        var dir = pointToSegment(bentPoints[i], {
          p1: connectPoints[i],
          p2: connectPoints[i + 1]
        });
        this.clockwise.push(dir >= 0 ? 0 : 1);
      }
      var startCrossAngle = this.getCrossAngle(headWidth, width * Math.abs(controlValue1), height * Math.abs(controlValue2) / 2);
      var headPoint = this.getHeadPoint(startCrossAngle, connectPoints[0], connectPoints[1], this.clockwise[0]);
      var endCrossAngle = this.getCrossAngle(tailWidth, height * Math.abs(1 - controlValue2), width * Math.abs(1 - controlValue1) / 2);
      var tailPoint = this.getTailPoint(endCrossAngle, connectPoints[2], connectPoints[3], this.clockwise[2]);
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseCurvedLine);

function _callSuper$3(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 三个控制点曲线
 */
var ThreeControlPointsCurvedLine = /*#__PURE__*/function (_BaseCurvedLine) {
  function ThreeControlPointsCurvedLine(model) {
    var _this;
    _classCallCheck(this, ThreeControlPointsCurvedLine);
    _this = _callSuper$3(this, ThreeControlPointsCurvedLine, [model]);
    _this.getControlPoints = function () {
      var _this$model = _this.model,
        width = _this$model.width,
        height = _this$model.height;
      return [{
        x: width * _this.controlValues[0],
        y: height * _this.controlValues[1] / 2
      }, {
        x: width * (_this.controlValues[2] + _this.controlValues[0]) / 2,
        y: height * _this.controlValues[1]
      }, {
        x: width * _this.controlValues[2],
        y: height * (1 + _this.controlValues[1]) / 2
      }];
    };
    return _this;
  }
  _inherits(ThreeControlPointsCurvedLine, _BaseCurvedLine);
  return _createClass(ThreeControlPointsCurvedLine, [{
    key: "getDefaultControlValues",
    value: function getDefaultControlValues() {
      return [0.5, 0.5, 0.5];
    }
  }, {
    key: "getLinePath",
    value: function getLinePath() {
      var width = this.model.width;
      var _this$getControlPoint = this.getControlPoints(),
        _this$getControlPoint2 = _slicedToArray(_this$getControlPoint, 3),
        point1 = _this$getControlPoint2[0],
        point2 = _this$getControlPoint2[1],
        point3 = _this$getControlPoint2[2];
      return {
        svgPath: "M".concat(this.headEnd.point.x, " ").concat(this.headEnd.point.y, " ") + "A".concat(point1.x, " ").concat(point1.y, " 0 0 ").concat(this.clockwise[0], " ").concat(point1.x, " ").concat(point1.y, " ") + "A".concat(point2.x - point1.x, " ").concat(point1.y, " 0 0 ").concat(this.clockwise[1], " ").concat(point2.x, " ").concat(point2.y, " ") + "A".concat(point2.x - point1.x, " ").concat(point3.y - point2.y, " 0 0 ").concat(this.clockwise[2], " ").concat(point3.x, " ").concat(point3.y, " ") + "A".concat(width - point3.x, " ").concat(point3.y - point2.y, " 0 0 ").concat(this.clockwise[3], " ").concat(this.tailEnd.point.x, " ").concat(this.tailEnd.point.y),
        fillMode: FillMode.NONE
      };
    }
  }, {
    key: "updateEndPoints",
    value: function updateEndPoints() {
      var _this$model2 = this.model,
        width = _this$model2.width,
        height = _this$model2.height;
      var headWidth = this.headEnd.getEndStrokeWidth();
      var tailWidth = this.tailEnd.getEndStrokeWidth();
      var _this$controlValues = _slicedToArray(this.controlValues, 3),
        controlValue1 = _this$controlValues[0],
        controlValue2 = _this$controlValues[1],
        controlValue3 = _this$controlValues[2];
      var connectPoints = [{
        x: 0,
        y: 0
      }, {
        x: width * controlValue1,
        y: height * controlValue2 / 2
      }, {
        x: width * (controlValue1 + controlValue3) / 2,
        y: height * controlValue2
      }, {
        x: width * controlValue3,
        y: height * (1 + controlValue2) / 2
      }, {
        x: width,
        y: height
      }];
      var bentPoints = [{
        x: width * controlValue1,
        y: 0
      }, {
        x: width * controlValue1,
        y: height * controlValue2
      }, {
        x: width * controlValue3,
        y: height * controlValue2
      }, {
        x: width * controlValue3,
        y: height
      }];
      this.clockwise = [];
      for (var i = 0; i + 1 < connectPoints.length; i++) {
        var dir = pointToSegment(bentPoints[i], {
          p1: connectPoints[i],
          p2: connectPoints[i + 1]
        });
        this.clockwise.push(dir >= 0 ? 0 : 1);
      }
      var startCrossAngle = this.getCrossAngle(headWidth, width * Math.abs(controlValue1), height * Math.abs(controlValue2) / 2);
      var headPoint = this.getHeadPoint(startCrossAngle, connectPoints[0], connectPoints[1], this.clockwise[0]);
      var endCrossAngle = this.getCrossAngle(tailWidth, width * Math.abs(1 - controlValue3), height * Math.abs(1 - controlValue2) / 2);
      var tailPoint = this.getTailPoint(endCrossAngle, connectPoints[3], connectPoints[4], this.clockwise[3]);
      this.headEnd.updateEndPoint(headPoint.x, headPoint.y);
      this.tailEnd.updateEndPoint(tailPoint.x, tailPoint.y);
    }
  }]);
}(BaseCurvedLine);

var _GraphicsParserMap;
var GraphicsParserMap = (_GraphicsParserMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_GraphicsParserMap, GraphicsType.CUSTOM, Custom), GraphicsType.RECT, Rect), GraphicsType.LINE, StraightLine), GraphicsType.STRAIGHT_CONNECTOR, StraightLine), GraphicsType.BENT_CONNECTOR_0, NoneControlPointBentLine), GraphicsType.BENT_CONNECTOR_1, SingleControlPointBentLine), GraphicsType.BENT_CONNECTOR_2, TwoControlPointsBentLine), GraphicsType.BENT_CONNECTOR_3, ThreeControlPointsBentLine), GraphicsType.CURVED_CONNECTOR_0, NoneControlPointCurvedLine), GraphicsType.CURVED_CONNECTOR_1, SingleControlPointCurvedLine), _defineProperty(_defineProperty(_GraphicsParserMap, GraphicsType.CURVED_CONNECTOR_2, TwoControlPointsCurvedLine), GraphicsType.CURVED_CONNECTOR_3, ThreeControlPointsCurvedLine));
var GraphicsParserKeys = Object.keys(GraphicsParserMap);
function createGraphicsParser(model) {
  if (GraphicsParserMap[model.type]) {
    return new GraphicsParserMap[model.type](model);
  }
  return new SpreadJSShape(model);
}
/**
 * 用来判断类型变更后，是否还是相同的parser
 */
function isSameParserWhenGraphicsTypeChange(prevType, newType) {
  if (prevType === newType) return true;
  var length = GraphicsParserKeys.length;
  for (var index = 0; index < length; index++) {
    var type = GraphicsParserKeys[index];
    // 为不同的parser
    if (type === prevType || type === newType) return false;
  }
  // 均为SpreadJSShape
  return true;
}

function _callSuper$2(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
var CANVAS_PATH_RENDER_ID = 'canvas-path-render';
var PathRenderComponent = /*#__PURE__*/function (_SvgGraphics) {
  function PathRenderComponent(model) {
    var _this;
    _classCallCheck(this, PathRenderComponent);
    _this = _callSuper$2(this, PathRenderComponent);
    _this.promiseImageLoaded = function () {
      var _a, _b;
      if (!imageCache.requestListInfo.isLoading || !(((_a = _this.model.fillStyle) === null || _a === void 0 ? void 0 : _a.imageFill) || ((_b = _this.model.fillStyle) === null || _b === void 0 ? void 0 : _b.patternFill))) {
        return Promise.resolve();
      }
      // 如果当前请求map中匹配的到，则说明此图片还未加载完成，如果没有则说明没有此图片或者已渲染完成
      return imageCache.requestListInfo.requestMap.get(_this.getImageUrl());
    };
    _this.isImageLoaded = function () {
      var _a, _b;
      if (!imageCache.requestListInfo.isLoading || !(((_a = _this.model.fillStyle) === null || _a === void 0 ? void 0 : _a.imageFill) || ((_b = _this.model.fillStyle) === null || _b === void 0 ? void 0 : _b.patternFill))) {
        return true;
      }
      // 如果当前请求map中匹配的到，则说明此图片还未加载完成，如果没有则说明没有此图片或者已渲染完成
      return !imageCache.requestListInfo.requestMap.has(_this.getImageUrl());
    };
    _this.addImageFilter = function () {
      var _a;
      var _this$model = _this.model,
        filter = _this$model.filter,
        fillStyle = _this$model.fillStyle;
      if (!(filter === null || filter === void 0 ? void 0 : filter.imageFilter) || !ImageFilter.isShowImageFilter(filter === null || filter === void 0 ? void 0 : filter.imageFilter) || !(fillStyle === null || fillStyle === void 0 ? void 0 : fillStyle.imageFill)) {
        return;
      }
      var filters = ImageFilter.generateImageFilter(filter.imageFilter, (_a = filter.forbidWebgl) !== null && _a !== void 0 ? _a : false);
      filters.forEach(function (filter) {
        _this.addFilter(filter);
      });
    };
    _this.model = model;
    _this.id = CANVAS_PATH_RENDER_ID;
    _this.updateStyles();
    return _this;
  }
  _inherits(PathRenderComponent, _SvgGraphics);
  return _createClass(PathRenderComponent, [{
    key: "updateModel",
    value: function updateModel(model) {
      this.model = model;
      this.updateStyles();
    }
  }, {
    key: "applyFullPath",
    value: function applyFullPath(canvas) {
      this.applyPath(canvas);
    }
  }, {
    key: "getImageUrl",
    value: function getImageUrl() {
      var _a;
      var _this$model2 = this.model,
        frame = _this$model2.frame,
        path = _this$model2.path;
      var _this$model$fillStyle = this.model.fillStyle,
        patternFill = _this$model$fillStyle.patternFill,
        imageFill = _this$model$fillStyle.imageFill;
      var url = '';
      if (patternFill) {
        url = PatternFill.getPatternSvgUrl(patternFill, {
          frame: frame,
          fillMode: (_a = path.fillMode) !== null && _a !== void 0 ? _a : FillMode.NORMAL
        });
      } else if (imageFill) {
        url = imageFill.src;
      }
      return url;
    }
  }, {
    key: "updateStyles",
    value: function updateStyles() {
      var _a;
      var _this$model3 = this.model,
        frame = _this$model3.frame,
        path = _this$model3.path;
      if (path.segments) {
        this.segments = path.segments;
      } else {
        this.path = path.svgPath;
      }
      this.x = frame.left;
      this.y = frame.top;
      var _path$scaleX = path.scaleX,
        scaleX = _path$scaleX === void 0 ? 1 : _path$scaleX,
        _path$scaleY = path.scaleY,
        scaleY = _path$scaleY === void 0 ? 1 : _path$scaleY;
      this.scaleX = scaleX;
      this.scaleY = scaleY;
      this.fill = Fill.None;
      if (this.needFill()) {
        setFillStyle(this, this.model.fillStyle, {
          frame: frame,
          fillMode: (_a = path.fillMode) !== null && _a !== void 0 ? _a : FillMode.NORMAL,
          scaleX: scaleX,
          scaleY: scaleY,
          type: this.model.type
        });
      }
      this.generateLineStyle();
      this.filters = [];
      // 图片滤镜需要在形状滤镜之前添加，否则会出现图片偏移
      this.addImageFilter();
    }
  }, {
    key: "needFill",
    value: function needFill() {
      var _this$model4 = this.model,
        path = _this$model4.path,
        type = _this$model4.type;
      var length = this.segments.length;
      var start = this.segments[0];
      var end = this.segments[length - 1];
      // 存在闭合指令或者曲线首尾重合，则认为是闭合曲线
      var isClosePath = path.svgPath.toLowerCase().indexOf('z') !== -1 || length > 1 && start.x === end.x && start.y === end.y;
      return path.fillMode !== FillMode.NONE && (isClosePath || !!path.isLineEndPath || type === GraphicsType.CUSTOM);
    }
  }, {
    key: "generateLineStyle",
    value: function generateLineStyle() {
      var _this$model5 = this.model,
        strokeStyle = _this$model5.strokeStyle,
        path = _this$model5.path,
        frame = _this$model5.frame;
      if (!strokeStyle) {
        this.stroke = Fill.None;
        // 无边框时需要重置宽度，避免原始边框宽度影响元素尺寸
        this.strokeWidth = 0;
        this.hitStrokeWidth = 0;
        return;
      }
      var stroke = new Stroke(strokeStyle, path, frame);
      this.hitStrokeWidth = stroke.hitStrokeWidth;
      this.strokeWidth = stroke.strokeWidth;
      this.stroke = stroke.strokeFill;
      this.strokeLineCap = stroke.lineCap;
      this.strokeLineJoin = stroke.lineJoin;
      this.strokeDash = stroke.lineDash;
    }
  }]);
}(SvgGraphics);

function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
var CANVAS_GRAPHICS_RENDER_ID = 'canvas-graphics-render';
var GraphicsRenderComponent = /*#__PURE__*/function (_Container) {
  function GraphicsRenderComponent(model) {
    var _this;
    _classCallCheck(this, GraphicsRenderComponent);
    _this = _callSuper$1(this, GraphicsRenderComponent);
    _this.getTextRect = function () {
      if (_this.isLineType()) {
        return;
      }
      return _this.parser.getTextRect();
    };
    _this.promiseImageLoaded = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
        var promiseArr;
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              promiseArr = [];
              this.graphicChildren.forEach(function (child) {
                var promise = child.promiseImageLoaded();
                if (promise) {
                  promiseArr.push(promise["catch"](function (err) {
                    console.error('[alloy-graphics]image-cache requestMap error', err);
                  }));
                }
              });
              return _context.abrupt("return", Promise.all(promiseArr));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    };
    _this.isImageLoaded = function () {
      var isImageLoaded = true;
      _this.graphicChildren.forEach(function (child) {
        var loaded = child.isImageLoaded();
        if (!loaded) {
          isImageLoaded = false;
          return;
        }
      });
      return isImageLoaded;
    };
    _this.hasFillOrStroke = function () {
      var _this$model = _this.model,
        fillStyle = _this$model.fillStyle,
        strokeStyle = _this$model.strokeStyle;
      return !(fillStyle === null || fillStyle === void 0 ? void 0 : fillStyle.noFill) || !!strokeStyle;
    };
    if (!model) return _possibleConstructorReturn(_this);
    _this.model = model;
    _this.prevModel = model;
    _this.id = CANVAS_GRAPHICS_RENDER_ID;
    _this.graphicChildren = [];
    _this.updateParser();
    _this.updatePathRender();
    _this.addEffectFilters();
    return _this;
  }
  _inherits(GraphicsRenderComponent, _Container);
  return _createClass(GraphicsRenderComponent, [{
    key: "updateModel",
    value: function updateModel(model) {
      var _this2 = this;
      if (!model) return;
      this.prevModel = this.model;
      this.model = model;
      this.updateParser();
      // update时model长度可能与children不一致，以model长度为准
      // 使graphicChildren中的数量与model保持一致
      var diffLength = this.graphicChildren.length - this.pathArray.length;
      if (diffLength > 0) {
        // graphicChildren中元素较多时
        for (var i = 0; i < Math.abs(diffLength); i++) {
          var child = this.graphicChildren[this.graphicChildren.length - 1];
          this.removeChild(child);
          child.dispose();
          this.graphicChildren.pop();
        }
      } else if (diffLength < 0) {
        // model中元素较多时
        var minLength = this.graphicChildren.length;
        for (var _i = 0; _i < Math.abs(diffLength); _i++) {
          var path = this.pathArray[minLength + _i];
          var component = new PathRenderComponent({
            path: path,
            frame: this.model.frame,
            filter: this.model.filter,
            fillStyle: this.getFillStyle(path),
            strokeStyle: this.model.strokeStyle,
            type: this.model.path.type
          });
          this.addChild(component);
          this.graphicChildren.push(component);
        }
      }
      this.pathArray.forEach(function (path, index) {
        _this2.graphicChildren[index].updateModel({
          path: path,
          frame: _this2.model.frame,
          filter: _this2.model.filter,
          fillStyle: _this2.getFillStyle(path),
          strokeStyle: _this2.getStorkeStyle(path),
          type: _this2.model.path.type
        });
      });
      this.addEffectFilters();
    }
  }, {
    key: "addEffectFilters",
    value: function addEffectFilters() {
      var _this3 = this;
      var _a;
      // 没有填充和边框时不添加效果
      if (!((_a = this.model.filter) === null || _a === void 0 ? void 0 : _a.effect) || !this.hasFillOrStroke()) {
        this.filters.forEach(function (filter) {
          _this3.removeFilter(filter);
        });
        return;
      }
      var fillStyle = this.model.fillStyle;
      var isPicture = !!(fillStyle === null || fillStyle === void 0 ? void 0 : fillStyle.imageFill);
      var _this$model$filter = this.model.filter,
        effect = _this$model$filter.effect,
        _this$model$filter$fi = _this$model$filter.filterDisplayOptions,
        filterDisplayOptions = _this$model$filter$fi === void 0 ? DefaultDisplayOptions : _this$model$filter$fi,
        _this$model$filter$fo = _this$model$filter.forbidWebgl,
        forbidWebgl = _this$model$filter$fo === void 0 ? false : _this$model$filter$fo;
      var filters = generateEffectFilters(effect, {
        forbidWebgl: forbidWebgl,
        isPicture: isPicture,
        filterDisplayOptions: filterDisplayOptions
      });
      this.filters = [];
      filters.forEach(function (filter) {
        _this3.addFilter(filter);
      });
    }
  }, {
    key: "updateParser",
    value: function updateParser() {
      var _a, _b, _c, _d;
      var type = this.model.path.type;
      var prevType = this.prevModel.path.type;
      var props = Object.assign(Object.assign({}, this.model.path), {
        width: this.model.frame.width,
        height: this.model.frame.height,
        lineWidth: (_a = this.model.strokeStyle) === null || _a === void 0 ? void 0 : _a.lineWidth,
        headEnd: (_b = this.model.strokeStyle) === null || _b === void 0 ? void 0 : _b.headEnd,
        tailEnd: (_c = this.model.strokeStyle) === null || _c === void 0 ? void 0 : _c.tailEnd,
        minEndStrokeWidth: (_d = this.model.strokeStyle) === null || _d === void 0 ? void 0 : _d.minEndStrokeWidth
      });
      if (!this.parser || type !== prevType) {
        this.parser = createGraphicsParser(props);
      } else {
        this.parser.update(props);
      }
      this.updateSvgArray();
    }
  }, {
    key: "updatePathRender",
    value: function updatePathRender() {
      var _this4 = this;
      this.pathArray.forEach(function (path) {
        var pathRenderModel = {
          path: path,
          frame: _this4.model.frame,
          filter: _this4.model.filter,
          fillStyle: _this4.getFillStyle(path),
          strokeStyle: _this4.getStorkeStyle(path),
          type: _this4.model.path.type
        };
        var component = new PathRenderComponent(pathRenderModel);
        _this4.addChild(component);
        _this4.graphicChildren.push(component);
      });
    }
  }, {
    key: "getFillStyle",
    value: function getFillStyle(path) {
      var _a;
      if (path.isLineEndPath) {
        // 线条箭头的填充为 stroke 的 fillStyle
        return (_a = this.model.strokeStyle) === null || _a === void 0 ? void 0 : _a.fillStyle;
      }
      if (path.isCompoundPath && !path.needFill) {
        return {
          noFill: true
        };
      }
      return this.model.fillStyle;
    }
  }, {
    key: "getStorkeStyle",
    value: function getStorkeStyle(path) {
      if (path.isCompoundPath) {
        return Object.assign(Object.assign({}, this.model.strokeStyle), {
          lineWidth: path.widthPercent * (this.model.strokeStyle.lineWidth || this.model.strokeStyle.minStrokeWidth || 0),
          fillStyle: path.widthPercent ? this.model.strokeStyle.fillStyle : {
            noFill: true
          }
        });
      }
      return this.model.strokeStyle;
    }
  }, {
    key: "isLineType",
    value: function isLineType() {
      var _this5 = this;
      return Object.values(LineType).filter(function (type) {
        return type === _this5.model.path.type;
      }).length === 1;
    }
  }, {
    key: "updateSvgArray",
    value: function updateSvgArray() {
      var _a, _b;
      var _this$model2 = this.model,
        frame = _this$model2.frame,
        path = _this$model2.path,
        strokeStyle = _this$model2.strokeStyle;
      // 类型、宽高、控制点、线端、复合类型或者 pathList 变化时，需要重新获取 path
      if (!this.pathArray || frame.width !== this.prevModel.frame.width || frame.height !== this.prevModel.frame.height || path.type !== this.prevModel.path.type || !this.judgeControlValuesSame(path.controlValues, this.prevModel.path.controlValues) || this.lineEndChange(strokeStyle) || this.pathListChange(path) || (strokeStyle === null || strokeStyle === void 0 ? void 0 : strokeStyle.compoundType) !== ((_a = this.prevModel.strokeStyle) === null || _a === void 0 ? void 0 : _a.compoundType) || (strokeStyle === null || strokeStyle === void 0 ? void 0 : strokeStyle.isOutsizeBorder) !== ((_b = this.prevModel.strokeStyle) === null || _b === void 0 ? void 0 : _b.isOutsizeBorder)) {
        this.pathArray = this.parser.svgPathInRect();
        if (strokeStyle) {
          // 复合类型与图形外部边框需要调整/生成新path
          this.pathArray = this.parser.getPathWithCompoundType(this.pathArray, strokeStyle);
        }
      }
    }
  }, {
    key: "pathListChange",
    value: function pathListChange(path) {
      var _a;
      var pathList = this.prevModel.path.pathList;
      if (!pathList && !path.pathList) {
        return false;
      }
      if ((pathList === null || pathList === void 0 ? void 0 : pathList.length) !== ((_a = path.pathList) === null || _a === void 0 ? void 0 : _a.length)) {
        return true;
      }
      var change = false;
      path.pathList.forEach(function (item, index) {
        if (!item || !(pathList === null || pathList === void 0 ? void 0 : pathList[index])) {
          change = true;
          return;
        }
        var diffProps = Object.keys(item).filter(function (key) {
          var _a;
          return item[key] !== ((_a = pathList === null || pathList === void 0 ? void 0 : pathList[index]) === null || _a === void 0 ? void 0 : _a[key]);
        });
        if (diffProps.length > 0) {
          change = true;
          return;
        }
      });
      return change;
    }
  }, {
    key: "lineEndChange",
    value: function lineEndChange(stroke) {
      var _a, _b, _c, _d, _e, _f;
      var _ref = this.prevModel.strokeStyle || {},
        lineWidth = _ref.lineWidth,
        headEnd = _ref.headEnd,
        tailEnd = _ref.tailEnd;
      return (stroke === null || stroke === void 0 ? void 0 : stroke.lineWidth) !== lineWidth || ((_a = stroke === null || stroke === void 0 ? void 0 : stroke.headEnd) === null || _a === void 0 ? void 0 : _a.lineEndType) !== (headEnd === null || headEnd === void 0 ? void 0 : headEnd.lineEndType) || ((_b = stroke === null || stroke === void 0 ? void 0 : stroke.headEnd) === null || _b === void 0 ? void 0 : _b.lengthType) !== (headEnd === null || headEnd === void 0 ? void 0 : headEnd.lengthType) || ((_c = stroke === null || stroke === void 0 ? void 0 : stroke.headEnd) === null || _c === void 0 ? void 0 : _c.widthType) !== (headEnd === null || headEnd === void 0 ? void 0 : headEnd.widthType) || ((_d = stroke === null || stroke === void 0 ? void 0 : stroke.tailEnd) === null || _d === void 0 ? void 0 : _d.lineEndType) !== (tailEnd === null || tailEnd === void 0 ? void 0 : tailEnd.lineEndType) || ((_e = stroke === null || stroke === void 0 ? void 0 : stroke.tailEnd) === null || _e === void 0 ? void 0 : _e.lengthType) !== (tailEnd === null || tailEnd === void 0 ? void 0 : tailEnd.lengthType) || ((_f = stroke === null || stroke === void 0 ? void 0 : stroke.tailEnd) === null || _f === void 0 ? void 0 : _f.widthType) !== (tailEnd === null || tailEnd === void 0 ? void 0 : tailEnd.widthType);
    }
  }, {
    key: "judgeControlValuesSame",
    value: function judgeControlValuesSame(newControlValues, oldControlValues) {
      if (!oldControlValues && !newControlValues) return true;
      if (newControlValues && oldControlValues) {
        if (newControlValues.length !== oldControlValues.length) {
          return false;
        }
        for (var i = 0; i < newControlValues.length; i++) {
          if (Math.abs(newControlValues[i] - oldControlValues[i]) > 1e-4) {
            return false;
          }
        }
        return true;
      }
      return false;
    }
  }]);
}(Container);

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ComponentWrapper = /*#__PURE__*/function (_Container) {
  function ComponentWrapper(options) {
    var _this;
    _classCallCheck(this, ComponentWrapper);
    _this = _callSuper(this, ComponentWrapper);
    _this.update = function (options) {
      _this.options = options;
      var model = _this.getRenderComponentModel();
      _this.renderComponents.updateModel(model);
      _this.updateTransform();
    };
    _this.promiseImageLoaded = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
        var _a, _b;
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (_b = (_a = this.renderComponents).promiseImageLoaded) === null || _b === void 0 ? void 0 : _b.call(_a);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    };
    _this.isImageLoaded = function () {
      var _a, _b;
      return (_b = (_a = _this.renderComponents).isImageLoaded) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    _this.getTextRect = function () {
      return _this.renderComponents.getTextRect();
    };
    _this.getParser = function () {
      return _this.renderComponents.parser;
    };
    _this.updateTransform = function () {
      var _this$options$frame = _this.options.frame,
        width = _this$options$frame.width,
        height = _this$options$frame.height,
        left = _this$options$frame.left,
        top = _this$options$frame.top,
        flipH = _this$options$frame.flipH,
        flipV = _this$options$frame.flipV,
        rotate = _this$options$frame.rotate;
      // 设置位移以及旋转的中心点（为了避免浮点数坐标造成的模糊，均向下取整）
      _this.x = Math.floor(left) + Math.floor(width / 2); // pivotX的设置会令图像产生负向平移，所以需要补回来
      _this.y = Math.floor(top) + Math.floor(height / 2);
      _this.pivotX = Math.floor(width / 2);
      _this.pivotY = Math.floor(height / 2);
      // 旋转
      _this.angle = rotate || 0;
      // 翻转
      _this.scaleX = flipH ? -1 : 1;
      _this.scaleY = flipV ? -1 : 1;
    };
    _this.options = options;
    var model = _this.getRenderComponentModel();
    _this.renderComponents = new GraphicsRenderComponent(model);
    _this.addChild(_this.renderComponents);
    _this.updateTransform();
    return _this;
  }
  _inherits(ComponentWrapper, _Container);
  return _createClass(ComponentWrapper, [{
    key: "getRenderComponentModel",
    value: function getRenderComponentModel() {
      var frame = Object.assign(Object.assign({}, this.options.frame), {
        left: 0,
        top: 0
      });
      return Object.assign(Object.assign({}, this.options), {
        frame: frame
      });
    }
  }]);
}(Container);

var Graphics = /*#__PURE__*/function () {
  function Graphics(options) {
    _classCallCheck(this, Graphics);
    this.options = options;
    this.renderComponents = new ComponentWrapper(options);
    this.wrapper = new Container();
    this.wrapper.addChild(this.renderComponents);
  }
  /**
   * 图片资源是否加载完成
   */
  return _createClass(Graphics, [{
    key: "isImageLoaded",
    get: function get() {
      var _a, _b;
      return !!((_b = (_a = this.renderComponents).isImageLoaded) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
  }, {
    key: "update",
    value: function update(options) {
      this.options = options;
      this.renderComponents.update(options);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _a;
      this.renderComponents.dispose();
      (_a = this.canvas) === null || _a === void 0 ? void 0 : _a.dispose();
    }
    /**
     * 异步绘制图形到指定画布，会等待图片资源加载完成后进行绘制
     * @param ctx
     */
  }, {
    key: "render",
    value: function render(ctx) {
      var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
        var canvas;
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (_b = (_a = this.renderComponents).promiseImageLoaded) === null || _b === void 0 ? void 0 : _b.call(_a);
            case 2:
              canvas = new BrowserCanvas({
                "native": ctx.canvas,
                modifyNativeStyle: false,
                bindEvents: false
              });
              canvas.width = parseInt(ctx.canvas.style.width);
              canvas.height = parseInt(ctx.canvas.style.height);
              canvas.resolution = Math.ceil(window.devicePixelRatio);
              this.renderComponents.alpha = alpha;
              this.renderComponents.render(canvas);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * 同步绘制图形到指定画布，图片资源未加载时不会绘制图片，需要手动调用 promiseImageLoaded 方法保证图片加载完成
     * @param ctx
     */
  }, {
    key: "syncRender",
    value: function syncRender(ctx) {
      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var canvas = new BrowserCanvas({
        "native": ctx.canvas,
        modifyNativeStyle: false,
        bindEvents: false
      });
      canvas.resolution = Math.ceil(window.devicePixelRatio);
      this.wrapper.scaleX = scale;
      this.wrapper.scaleY = scale;
      this.renderComponents.alpha = alpha;
      this.wrapper.render(canvas);
    }
    /**
     * 确保图片资源加载完成
     */
  }, {
    key: "promiseImageLoaded",
    value: function promiseImageLoaded() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee2() {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (_b = (_a = this.renderComponents).promiseImageLoaded) === null || _b === void 0 ? void 0 : _b.call(_a);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * 获取绘制了图形的画布
     */
  }, {
    key: "getRenderedCanvas",
    value: function getRenderedCanvas() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee3() {
        var canvasElement;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.canvas) {
                canvasElement = document.createElement('canvas');
                this.bounds = new Bounds();
                this.canvas = new BrowserCanvas({
                  "native": canvasElement,
                  bindEvents: false
                });
              }
              this.canvas.clear();
              this.bounds.clear();
              this.bounds.addBounds(this.renderComponents.filterWorldBounds);
              this.canvas.width = this.bounds.width;
              this.canvas.height = this.bounds.height;
              this.canvas.resolution = Math.ceil(window.devicePixelRatio);
              this.renderComponents.x += -this.bounds.x;
              this.renderComponents.y += -this.bounds.y;
              // 确保异步资源均加载完成
              _context3.next = 11;
              return (_b = (_a = this.renderComponents).promiseImageLoaded) === null || _b === void 0 ? void 0 : _b.call(_a);
            case 11:
              this.renderComponents.render(this.canvas);
              return _context3.abrupt("return", this.canvas["native"]);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getParser",
    value: function getParser() {
      return this.renderComponents.getParser();
    }
    /**
     * 获取图形文字区域
     */
  }, {
    key: "getTextRect",
    value: function getTextRect() {
      return this.renderComponents.getTextRect();
    }
    /**
     * 获取元素渲染的区域大小
     */
  }, {
    key: "getRenderBounds",
    value: function getRenderBounds() {
      return this.renderComponents.worldBounds;
    }
    /**
     * 更新元素渲染偏移量
     * @param x
     * @param y
     */
  }, {
    key: "updatePosition",
    value: function updatePosition(x, y) {
      this.renderComponents.x += x;
      this.renderComponents.y += y;
    }
  }]);
}();

export { Graphics, GraphicsRenderComponent, LineEndType, LineEndWidthType, createGraphicsParser, isSameParserWhenGraphicsTypeChange };
//# sourceMappingURL=index.esm.js.map
